import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const translations = {
  en: {
    accessDenied: 'Access denied',
    actions: 'Actions',
    active: 'Active',
    activeSessions: 'Active Sessions',
    activeSessionsManagement: 'Active Sessions Management',
    actual: 'Actual',
    actualCash: 'Actual Cash',
    aCuentaDe: 'A cuenta de',
    add: 'Add',
    addArea: 'Add area',
    addCategory: 'Add Category',
    addCheck: 'Add Check',
    addComboItem: 'Add Combo Item',
    addGroup: 'Add Group',
    addItem: 'Add Item',
    addItems: 'Add Items',
    addNewCategory: 'Add New Category',
    addNewCost: 'Add New Cost',
    addNewInventoryItem: 'Add New Invoice',
    addNewSpecial: 'Add New Special',
    addNewTheme: 'Add New Theme',
    addNewUser: 'Add New User',
    addNotesAboutShift: 'Add notes about this shift...',
    addOrder: 'Add Order',
    addPhoto: 'Add photo',
    addProduct: 'Add Product',
    addProductionRun: 'Add Production Run',
    addProducts: 'Add Products',
    address: 'Address',
    addressPlaceholder: 'Enter address',
    addSpecial: 'Add Special',
    addTab: 'Add Tab',
    addTable: 'Add Table',
    addTheme: 'Add Theme',
    addTip: 'Add Tip',
    addUser: 'Add User',
    admin: 'Admin',
    adminDashboardTabs: 'Admin Dashboard Tabs',
    administration: 'Administration',
    adminLayout: 'Admin Layout',
    adminLayoutInfo: 'Drag sections between tabs to reorganize. Toggle visibility with the eye icon.',
    advancedAnalytics: 'Advanced Analytics',
    afterDiscount: 'after discount',
    ago: 'ago',
    alcoholic: 'Alcoholic',
    alignment: 'Alignment',
    all: 'All',
    allAreas: 'All areas',
    allCategories: 'All Categories',
    allergens: 'Allergens',
    allergyInfo: 'Allergy Information',
    allGroups: 'All Groups',
    allOrders: 'All Orders',
    allowedFormats: 'Allowed formats',
    allProducts: 'All Products',
    allRegisters: 'All Registers',
    allTime: 'All Time',
    alphabeticalOrder: 'Alphabetical Order',
    amount: 'Amount',
    analysis: 'Analysis',
    analytics: 'Analytics',
    analyze: 'Analyze',
    analyzing: 'Analyzing',
    and: 'and',
    anOpenOrderWithThisNameAlreadyExists: 'An open order with this name already exists for this table.',
    anticipo: 'Advance Payment',
    appetizer: 'Appetizer',
    appliesTo: 'Applies To',
    apply: 'Apply',
    applyChanges: 'Apply Changes',
    applyDiscount: 'Apply Discount',
    applying: 'Applying...',
    applySpecial: 'Apply Special',
    approve: 'Approve',
    approved: 'Approved',
    approvedBy: 'Approved by',
    approvedPayouts: 'Approved Payouts',
    archived: 'Archived',
    area: 'Area',
    areaName: 'Area name',
    areYouSureDeleteItemCannotUndo: 'Are you sure you want to delete this item? This action cannot be undone.',
    assignItems: 'Assign Items',
    assignItemsToSplitChecks: 'Assign Items to Split Checks',
    attemptsRemaining: 'attempts remaining',
    authorizationCode: 'Authorization Code',
    auto: 'Auto',
    automaticThermalToBrowser: 'Automatic (thermal → browser)',
    autoUsesDesktopFallback: 'Auto: uses min(desktop, 2)',
    availability: 'Availability',
    available: 'Available',
    average: 'Average',
    averageActiveTablesPerDay: 'Average Active Tables Per Day',
    averagePricePerLiter: 'Average Price per Liter',
    avgFinishTime: 'Avg Finish Time',
    avgOrderTotal: 'Average Order Total',
    avgOrderTotalOverTime: 'Average Order Total Over Time',
    avgTipPerOrder: 'Average Tip per Order',
    back: 'Back',
    background: 'Background',
    backgroundColor: 'Background Color',
    backupCreated: 'Backup created successfully',
    backupData: 'Backup Data',
    BackupDatabase: 'Backup Database',
    backupDescription: 'Download a complete backup of your restaurant\'s database',
    backupFailed: 'Backup failed',
    backupInProgress: 'Creating backup...',
    bankTransfer: 'Bank Transfer',
    bar: 'Bar',
    barcode: 'Barcode',
    barcodescanner: 'Barcode Scanner',
    bartender: 'Bartender',
    baud: 'baud',
    baudRate: 'Baud Rate',
    beerProduction: 'Beer Production',
    beerProductionRuns: 'Production Runs',
    beerSales: 'Beer Sales',
    beforeDiscount: 'before discount',
    beverage: 'Beverage',
    billingAddress: 'Billing Address',
    bluetoothAlternative: 'Or use Bluefy browser for Bluetooth printing',
    bluetoothPrinter: 'Bluetooth Printer',
    border: 'Border',
    borderColor: 'Border Color',
    break: 'Break',
    breakEvenDays: 'Break Even (Days)',
    browserCompatibility: 'Browser Compatibility',
    browserOnly: 'Browser only',
    browserPrinting: 'Browser Printing',
    browserPrintingWillStillWork: 'Browser printing will still work',
    businessName: 'Business Name',
    busser: 'Busser',
    buyQuantity: 'Buy Quantity',
    buyXGetYFree: 'Buy X Get Y Free',
    byCategory: 'By Category',
    byDay: 'By Day',
    byGroup: 'By Group',
    byHour: 'By Hour',
    byMonth: 'By Month',
    byUser: 'By User',
    byWeek: 'By Week',
    byYear: 'By Year',
    calculation: 'Calculation',
    calories: 'Calories',
    cancel: 'Cancel',
    cancelled: 'Cancelled',
    cancelOrderConfirmation: 'Are you sure you want to cancel this order?',
    cannotCloseParentTab: 'Cannot close check: This tab has open child orders',
    cannotDeleteAdminUser: 'Cannot delete admin user',
    cannotDeleteCategory: 'Cannot delete category',
    cannotDeleteDefaultThemes: 'Cannot delete default themes',
    cannotForceLogoutSelf: 'You cannot force logout your own session',
    cantidad: 'Quantity',
    canvasHeight: 'Canvas Height',
    canvasWidth: 'Canvas Width',
    card: 'Card',
    cardCharge: 'Card Charge',
    cardholderName: 'Cardholder Name',
    cardNumber: 'Card Number',
    cardPaymentProcessed: 'Card payment processed successfully',
    cash: 'Cash',
    cashCount: 'Cash Count',
    cashDrawer: 'Cash Drawer',
    cashier: 'Cashier',
    cashReceived: 'Cash Received',
    cashSales: 'Cash Sales',
    categories: 'Categories',
    category: 'Category',
    categoryBreakdown: 'Category Breakdown',
    categoryCreated: 'Category created successfully',
    categoryDeleted: 'Category deleted successfully',
    categoryManagement: 'Category Management',
    categoryName: 'Category Name',
    categorySortOrder: 'Category Sort Order',
    categorySortOrderChangeInfo: 'This setting controls the order in which categories appear in the product selection screen',
    categoryUpdated: 'Category updated successfully',
    categoryVisibility: 'Category/Product Visibility & Order',
    celsius: '°C',
    centimeters: 'cm',
    cervezasGibbons: 'Cervezas Gibbons',
    change: 'Change',
    changeInSystemSettings: 'This can be changed in System Settings',
    changeLanguage: 'Change Language',
    changeOwed: 'Change Owed',
    changePassword: 'Change password',
    changePin: 'Change PIN',
    changesSaved: 'Changes saved successfully',
    characterLimit: 'Character limit',
    charged: 'Charged',
    chars: 'chars',
    chartPlaceholder: 'Chart implementation coming soon',
    chartVisualization: 'Chart Visualization',
    cheapest: 'Cheapest',
    check: 'Check',
    checkName: 'Check Name',
    checkPrinterOutput: 'Check printer output',
    checkRecombinedSuccessfully: 'Check recombined successfully',
    chef: 'Chef',
    chooseFile: 'Choose file',
    clear: 'Clear',
    clearAllItems: 'Clear All Items',
    clearAllItemsConfirm: 'Are you sure you want to archive all items? This will move all items in "New Orders", "In Progress", and "Finished" to archived status.',
    clearAllItemsSuccess: 'All items have been archived',
    clickConnectPrinterAndSelectPort: 'Click "Connect Printer" and select the port',
    clickToFinish: 'Click to finish',
    clickToRemove: 'Click to remove',
    clickToStart: 'Click to start',
    clickToViewDetails: 'Click to view details',
    close: 'Close',
    closeCheck: 'Close Check',
    closed: 'Closed',
    closedBy: 'Closed By',
    closedChecks: 'Closed Checks',
    closedOrders: 'Closed Orders',
    closedRegisters: 'Closed Registers',
    closeOrderConfirmation: 'Are you sure you want to close this order?',
    closeRegister: 'Close Register',
    closeThisCheck: 'Close this check',
    closing: 'Closing',
    closingCash: 'Closing Cash',
    collapse: 'Collapse',
    colorScheme: 'Color Scheme',
    columns: 'Columns',
    combine: 'Combine',
    combineCheck: 'Combine Check',
    combineChecks: 'Combine Checks',
    combinedTotal: 'Combined Total',
    combineOrders: 'Combine Orders',
    combineThisCheckWithAnotherCheck: 'Combine this check with another check',
    combineWarning: 'This action will move all items from the source order to the target order. The source order will be deleted and this action cannot be undone.',
    combineWarningMessage: 'This action will move all items from the selected order to the current order. The selected order will be deleted and cannot be undone.',
    combining: 'Combining...',
    comboDeal: 'Combo Deal',
    comboExample: 'Example',
    comboItems: 'Combo Items',
    comboPrice: 'Combo Price',
    commission: 'Commission',
    compatible: 'Compatible',
    completed: 'Completed',
    complimentaryOrder: 'Complimentary Order',
    conditions: 'Conditions',
    configure: 'Configure',
    confirm: 'Confirm',
    confirmCloseEmptyCheck: 'Are you sure you want to close this empty check?',
    confirmDelete: 'Are you sure you want to delete this payout',
    confirmDeleteArea: 'Delete this area?',
    confirmDeleteInventoryItem: 'Are you sure you want to delete this invoice?',
    confirmDeleteProduction: 'Are you sure you want to delete this production run?',
    confirmDeleteSpecial: 'Are you sure you want to delete this special?',
    confirmDeleteTheme: 'Are you sure you want to delete this theme?',
    confirmForceLogout: 'Are you sure you want to force logout this user?',
    confirmItemDeletion: 'Confirm Item Deletion',
    confirmLeaveWithPreorderItems: 'You have unsent items in preorder. Are you sure you want to leave?',
    confirmLogout: 'Are you sure you want to log out?',
    confirmPin: 'Confirm PIN',
    confirmReopenOrder: 'Are you sure you want to reopen this order?',
    connected: 'Connected',
    connecting: 'Connecting...',
    connectionFailed: 'Connection failed. Please check printer is connected and powered on.',
    connectionLost: 'Connection lost',
    connectionRestored: 'Connection restored',
    connectPrinter: 'Connect Printer',
    connectThermalPrinterUsb: 'Connect your thermal printer via USB',
    contains: 'Contains',
    continueWithoutTip: 'Continue Without Tip',
    cooking: 'Cooking',
    cookingInstructions: 'Cooking Instructions',
    cookTime: 'Cook Time',
    copy: 'Copy',
    cost: 'Cost',
    costManagement: 'Cost Management',
    costName: 'Cost Name',
    costoDeEnvio: 'Shipping Cost',
    costPerUnit: 'Cost/Unit',
    coupon: 'Coupon',
    create: 'Create',
    created: 'Created',
    createdBy: 'Created by',
    createDeposit: 'Add Deposit',
    createInvoice: 'Create Invoice',
    createNewOrder: 'Create New Order',
    createOrder: 'Create Order',
    createPayout: 'Create Payout',
    createSplitChecks: 'Create Split Checks',
    creating: 'Creating',
    creatingSplitChecks: 'Creating Split Checks...',
    Credentials: 'Credentials',
    creditCard: 'Credit Card',
    creditDebit: 'Credit/Debit',
    creditDebitCard: 'Credit/Debit Card',
    creditTips: 'Credit Card Tips',
    criteria: 'Criteria',
    crossMidnightTimeNote: 'Cross-midnight times are supported (e.g., 22:00 to 02:00 for late night specials)',
    crypto: 'Crypto',
    cups: 'cups',
    currency: '$',
    currentDetails: 'Current Details',
    currentDiscount: 'Current Discount',
    currentOrder: 'Current Order (Destination)',
    currentUser: 'Current User',
    customer: 'Customer',
    customerAddress: 'Customer Address',
    customerChangedMind: 'Customer changed mind',
    customerCity: 'City',
    customerComplaint: 'Customer complaint',
    customerName: 'Customer Name',
    customerPhone: 'Customer Phone',
    customerState: 'State',
    customerZip: 'ZIP Code',
    customItem: 'Custom item',
    customItemAdd: 'Add a custom item to this category',
    customItemName: 'Name',
    customItemNamePlaceholder: 'Item not on the menu',
    customItemNameRequired: 'Enter a name for the custom item',
    customItemPrice: 'Price',
    customItemPriceRequired: 'Enter a price of zero or more',
    customItemQuantity: 'Quantity',
    customItemQuantityRequired: 'Enter a quantity of at least 1',
    customItemsEnabled: 'Enable Custom Items',
    customItemsEnabledInfo: 'Adds a custom item button to every category on the order screen, for selling something that is not on the menu with a name and price typed at the till.',
    customItemsUsingCategory: 'past orders include custom items sold under this category',
    customName: 'Your custom name:',
    customTheme: 'Custom Theme',
    customTip: 'Custom Tip',
    cut: 'Cut',
    cvv: 'CVV',
    daily: 'Daily',
    dailyAutoLogout: 'Daily Auto-Logout',
    dailyAutoLogoutAt: 'Daily auto-logout at',
    dailyAutoLogoutDisabled: 'Daily auto-logout is disabled',
    dailyAutoLogoutEnabled: 'Daily Auto-Logout Enabled',
    dailyAutoLogoutInfo: 'All sessions are automatically logged out daily at 5:00 AM',
    dailyLogoutHour: 'Daily Logout Hour',
    dailyLogoutMinute: 'Daily Logout Minute',
    dailyLogoutTimezone: 'Daily Logout Timezone',
    dailyOperations: 'Daily Operations',
    dailySales: 'Daily Sales',
    dailySummary: 'Daily Summary',
    dark: 'Dark',
    darkTheme: 'Dark',
    dashboard: 'Dashboard',
    dataBackupReminder: 'Data backup reminder',
    dataExported: 'Data exported successfully',
    dataImported: 'Data imported successfully',
    dataRestored: 'Data restored successfully',
    date: 'Date',
    dateRange: 'Date Range',
    datetime: 'Date & Time',
    dayOfWeek: 'Day of Week',
    days: 'days',
    daysAgo: 'days ago',
    daysLabel: 'days',
    daysOfWeek: 'Days of Week',
    daysOpenInMonth: 'Days Open in Month',
    debitCard: 'Debit Card',
    decreaseQuantity: 'Decrease quantity',
    default: 'Default',
    defaultDark: 'Default Dark',
    defaultLight: 'Default Light',
    defaultSales: 'default sales',
    defaultStartupMode: 'Default Startup Mode',
    defineShiftTimes: 'Define Shift Times',
    delayed: 'Delayed',
    delete: 'Delete',
    deleteArea: 'Delete area',
    deleteCategory: 'Delete Category',
    deleteConfirmation: 'Are you sure you want to delete this item?',
    deleted: 'Deleted',
    deleteGroup: 'Delete Group',
    deleteItem: 'Delete Item',
    deleteOrder: 'Delete Order',
    deleteOrderConfirmation: 'Are you sure you want to delete this order? This action cannot be undone.',
    deleteProduct: 'Delete Product',
    deleteProductConfirmation: 'Are you sure you want to delete this product? This action cannot be undone.',
    deleteSpecial: 'Delete Special',
    deleteTable: 'Delete Table',
    deleteTableConfirmation: 'Are you sure you want to delete this table? This action cannot be undone.',
    deleteUser: 'Delete user',
    deleting: 'Deleting...',
    delivered: 'Delivered',
    deliveredBy: 'Delivered By',
    delivery: 'Delivery',
    deliveryNote: 'Delivery Note',
    deposit: 'Deposit',
    depositDescription: 'e.g., Bank deposit, cash from sales...',
    depositInfo: 'Add cash to the register (e.g., making change, adding cash from bank)',
    deposits: 'Deposits',
    descripcion: 'Description',
    deselectAll: 'Deselect All',
    desktopColumns: 'Desktop columns',
    dessert: 'Dessert',
    deviceIdentifier: 'Device',
    devLogin: 'Dev Login',
    difference: 'Difference',
    digitalMenu: 'Digital Menu',
    digitalMenuUrl: 'Digital Menu URL',
    digits: 'digits',
    dineIn: 'Dine In',
    direccionDeEnvio: 'Dirección de envío',
    disabled: 'Disabled',
    disableDailyLogout: 'Disable Daily Logout',
    disableMovement: 'Disable Movement',
    discardChanges: 'Discard changes?',
    disconnect: 'Disconnect',
    disconnected: 'Disconnected',
    disconnecting: 'Disconnecting...',
    discount: 'Discount',
    discountAmount: 'Discount Amount',
    discountByFixedAmount: 'Discount by fixed amount',
    discountByPercentage: 'Discount by percentage',
    discountPercentage: 'Discount Percentage',
    discountPercentCannotExceed100: 'Discount percent cannot exceed 100%',
    discountValue: 'Discount Value',
    displayAndTickets: 'Display + Tickets',
    displayOnly: 'Display Only',
    displayOrder: 'Display Order',
    dontMake: 'Don\'t Make',
    dontShowAgain: 'Don\'t show this again',
    download: 'Download',
    downloadBackup: 'Download Backup',
    downloadInvoice: 'Download Invoice',
    downloadQrPdf: 'Download QR PDF',
    dozen: 'dozen',
    draft: 'Draft',
    dragCategoriesBetweenGroups: 'Drag categories between groups to organize them. Changes are saved when you click Save.',
    dragCategoriesToAssignGroups: 'Categories are automatically assigned based on criteria. Edit criteria to change assignments.',
    dragDropFile: 'Drag and drop file here',
    dragToAdjust: 'Drag handles to adjust range',
    dragToReorder: 'Drag to reorder',
    dropCategoriesHere: 'Drop categories here',
    dueDate: 'Due Date',
    duplicate: 'Duplicate',
    duplicateNameInSplitChecks: 'Duplicate name in split checks',
    duration: 'Duration',
    each: 'each',
    earlierPaymentsKept: 'Payments already recorded stay on this check.',
    edit: 'Edit',
    editCategory: 'Edit Category',
    editInventoryItem: 'Edit Invoice',
    editItem: 'Edit Item',
    editOrder: 'Edit Order',
    editProduct: 'Edit Product',
    editProductionRun: 'Edit Production Run',
    editSpecial: 'Edit Special',
    editTable: 'Edit Table',
    editTheme: 'Edit Theme',
    editUser: 'Edit user',
    email: 'Email',
    emailPlaceholder: 'Enter email address',
    emailReceipt: 'Email Receipt',
    employee: 'Employee',
    emptyCheck: 'Empty Check',
    enabled: 'Enabled',
    enableDailyLogout: 'Enable Daily Logout',
    enableMovement: 'Enable Movement',
    endDate: 'End Date',
    english: 'English',
    enterDailySales: 'Enter daily sales',
    enterNameForTheSplitCheck: 'Enter name for the split check...',
    enterNewPassword: 'Enter new password',
    enterPin: 'Enter PIN (4-digits)',
    enterSalesPerTable: 'Enter sales per table',
    enterTabName: 'Enter tab name',
    enterYourPin: 'Enter your PIN to continue',
    entregadoPor: 'Delivered By',
    error: 'Error',
    errorClosingOrder: 'Error closing order',
    errorColor: 'Error Color',
    errorConnectingPrinter: 'Error connecting printer',
    errorDisconnectingPrinter: 'Error disconnecting printer',
    errorExportingInventory: 'Error exporting invoices',
    errorExportingStatistics: 'Error exporting statistics',
    errorFetchingTables: 'Error fetching tables',
    errorImportingInventory: 'Error importing invoices',
    errorInTest: 'Error in test',
    errorOpeningDrawer: 'Error opening drawer',
    errorRecombiningCheck: 'Error recombining check',
    exact: 'Exact',
    excludeProducts: 'Exclude Products',
    excludes: 'Excludes',
    exit: 'Exit',
    expand: 'Expand',
    expected: 'Expected',
    expectedCash: 'Expected Cash',
    expedite: 'Expedite',
    expenses: 'Expenses',
    expirationMonth: 'Expiration Month',
    expirationYear: 'Expiration Year',
    explainWhyItemNeedsDeleted: 'Explain why this item needs to be deleted...',
    export: 'Export',
    exportColCategoryArea: 'Category Area',
    exportColCategoryName: 'Category Name',
    exportColClosedBy: 'Closed By',
    exportColDontMake: 'Dont Make',
    exportColFinishedDate: 'Finished Date',
    exportColFinishedTime: 'Finished Time',
    exportColInProgressDate: 'In Progress Date',
    exportColInProgressTime: 'In Progress Time',
    exportColItemCreatedDate: 'Item Created Date',
    exportColItemCreatedTime: 'Item Created Time',
    exportColItemDiscount: 'Item Discount',
    exportColItemModifiedDate: 'Item Modified Date',
    exportColItemModifiedTime: 'Item Modified Time',
    exportColItemNote: 'Item Note',
    exportColItemPrice: 'Item Price',
    exportColItemStatus: 'Item Status',
    exportColLineTotal: 'Line Total',
    exportColOpenedBy: 'Opened By',
    exportColOrderCreatedDate: 'Order Created Date',
    exportColOrderCreatedTime: 'Order Created Time',
    exportColOrderedDate: 'Ordered Date',
    exportColOrderedTime: 'Ordered Time',
    exportColOrderId: 'Order ID',
    exportColOrderModifiedDate: 'Order Modified Date',
    exportColOrderModifiedTime: 'Order Modified Time',
    exportColOrderName: 'Order Name',
    exportColOrderProductId: 'Order Product ID',
    exportColOrderStatus: 'Order Status',
    exportColOrderTip: 'Order Tip',
    exportColPaymentType: 'Payment Type',
    exportColPrepTimeMinutes: 'Prep Time Minutes',
    exportColProductDescription: 'Product Description',
    exportColProductName: 'Product Name',
    exportColQuantity: 'Quantity',
    exportColTableName: 'Table Name',
    exportColTotalTimeMinutes: 'Total Time Minutes',
    exportColumns: 'Columns',
    exportColWaitTimeMinutes: 'Wait Time Minutes',
    exporting: 'Exporting',
    exportLanguage: 'Export Language',
    exportReport: 'Export Report',
    exportReports: 'Export Reports',
    exportSettings: 'Export Settings',
    fahrenheit: '°F',
    failedToApplyDiscount: 'Failed to apply discount',
    failedToCancelItem: 'Failed to cancel item',
    failedToCloseOrder: 'Failed to close order',
    failedToCreateOrder: 'Failed to create order',
    failedToDeleteArea: 'Failed to delete area',
    failedToDeleteEmptyOrderButItemsMovedSuccessfully: 'Failed to delete empty order, but items were moved successfully',
    failedToDeleteEmptySplitCheckOrderButItemsMovedSuccessfully: 'Failed to delete empty split check order, but items were moved successfully',
    failedToDeleteInventoryItem: 'Failed to delete invoice',
    failedToDeleteProduction: 'Failed to delete production run',
    failedToDeleteSpecial: 'Failed to delete special',
    failedToDeleteTheme: 'Failed to delete theme',
    failedToFetchCurrentOrderData: 'Failed to fetch current order data',
    failedToFetchExportData: 'Failed to fetch export data',
    failedToFetchIepsData: 'Failed to fetch IEPS data',
    failedToFetchInventory: 'Failed to fetch invoices',
    failedToFetchProductions: 'Failed to fetch production runs',
    failedToFetchSpecials: 'Failed to fetch specials',
    failedToFetchThemes: 'Failed to fetch themes',
    failedToLoadAreas: 'Failed to load areas',
    failedToLoadAvailableOrders: 'Failed to load available orders',
    failedToLoadPayouts: 'Failed to load payouts',
    failedToMoveItemToCurrentOrder: 'Failed to move item to current order',
    failedToMoveItemToParentCheck: 'Failed to move item to parent check',
    failedToSaveArea: 'Failed to save area',
    failedToSaveInventoryItem: 'Failed to save invoice',
    failedToSaveProduction: 'Failed to save production run',
    failedToSaveSpecial: 'Failed to save special',
    failedToSaveTheme: 'Failed to save theme',
    failedToUpdateOrder: 'Failed to update order',
    featured: 'Featured',
    featureSettings: 'Feature Settings',
    fecha: 'Date',
    feet: 'ft',
    fieldRequired: 'This field is required',
    filter: 'Filter',
    filterByCategory: 'Filter by Category',
    finalTotal: 'Final Total',
    financeInvoicing: 'Finance & Invoicing',
    finishDate: 'Finish Date',
    finished: 'Finished',
    firma: 'Signature',
    first: 'First',
    firstNames: 'First Names',
    fixedDiscount: 'Fixed Discount',
    floorPlanLayout: 'Floor Plan Layout',
    floorPlanTooSmall: 'Current tables need a minimum layout of',
    floorPlanTooSmallHint: 'Move or deactivate tables to reduce the minimum',
    fontFamily: 'Font Family',
    fontSize: 'Font Size',
    footer: 'Footer',
    footerMessages: 'Footer Messages',
    forceLogout: 'Force Logout',
    forThisTable: 'for this table',
    frequency: 'Frequency',
    friday: 'Friday',
    friend: 'Friend',
    from: 'from',
    fullCut: 'Full cut',
    fullLogin: 'Full Login',
    fullName: 'Full Name',
    fullscreen: 'Full Screen',
    generateInvoice: 'Generate Invoice',
    generatingPdf: 'Generating PDF...',
    getQuantity: 'Get Quantity',
    giftCard: 'Gift Card',
    glutenFree: 'Gluten Free',
    gotIt: 'Got It',
    grams: 'g',
    granularity: 'Time Granularity',
    gratuity: 'Gratuity',
    gridSnapDisabled: 'Disabled (free placement)',
    gridSnapSize: 'Grid Snap Size',
    group: 'Group',
    groupConfigurationNote: 'Groups are configured based on category area and name patterns. Changes will affect all analytics.',
    groupMeetup: 'Group Meetup',
    header: 'Header',
    headerInformation: 'Header Information',
    height: 'Height',
    hide: 'Hide',
    hideItem: 'Hide item',
    hideOptions: 'Hide Options',
    hidePastOrders: 'Hide Past Orders',
    hidePrintPreview: 'Hide print preview',
    holdCtrlOrCmd: 'Hold Ctrl (Windows) or Cmd (Mac) to select multiple',
    holdCtrlToSelectMultiple: 'Hold Ctrl/Cmd to select multiple',
    host: 'Host',
    hour: 'Hour',
    hourlyRate: 'Hourly Rate',
    hoursAgo: 'hours ago',
    howDidYouHearAboutUs: 'How did you hear about us',
    iepsCalculator: 'IEPS Tax Calculator',
    iepsReport: 'IEPS Report',
    ifTextCutOff: 'If text is cut off on the right, try a smaller width',
    import: 'Import',
    importe: 'Amount',
    imported: 'imported',
    importing: 'Importing',
    in: 'in',
    inactive: 'Inactive',
    inboundInvoices: 'Inbound Invoices',
    inches: 'in',
    included: 'included',
    includeDiscounts: 'Include Discounts',
    includeIvaBreakdown: 'Include IVA breakdown',
    includeQrCode: 'Include QR code',
    includes: 'Includes',
    includeSpecials: 'Include Specials',
    increaseQuantity: 'Increase quantity',
    ingredients: 'Ingredients',
    inProgress: 'In Progress',
    inStock: 'In Stock',
    instructions: 'Instructions',
    insufficientCash: 'Insufficient cash received',
    insufficientPermissions: 'Insufficient permissions',
    insumoInvoice: 'Insumo (Invoice)',
    intoSeparateItems: 'into separate items',
    invalidCredentials: 'Invalid credentials',
    invalidCsvFormat: 'Invalid CSV format. Expected headers: Name, Purchase Date, Price, IVA',
    invalidEmail: 'Invalid email address',
    invalidFormat: 'Invalid format',
    invalidPhone: 'Invalid phone number',
    inventory: 'Inventory',
    inventoryManagement: 'Inventory Management',
    inventoryReport: 'Inventory Report',
    invoice: 'Invoice',
    invoiceDate: 'Invoice Date',
    invoiceDetails: 'Invoice Details',
    invoiceGeneratedOn: 'Invoice generated on',
    invoiceHistory: 'Invoice History',
    invoiceManagement: 'Invoice Management',
    invoiceNotes: 'Invoice Notes',
    invoiceNumber: 'Invoice Number',
    invoices: 'Invoices',
    iosPrintHelp: 'Choose how to print your receipt',
    iosPrintOptions: 'Print Options',
    item: 'Item',
    itemNotAvailable: 'Item not available',
    items: 'Items',
    itemsAddedSuccessfully: 'Items added successfully!',
    itemSortOrder: 'Item Sort Order',
    itemsOverTime: 'Items Over Time',
    itemsToBeMoved: 'Items to be moved',
    itemsToBeMovedBackToParentCheck: 'Items to be moved back to parent check',
    itemsToMove: 'Items to Move',
    itemVisibility: 'Item Visibility',
    iva: 'IVA',
    ivaIncluded: 'IVA Included',
    justNow: 'Just now',
    kdsEnabled: 'Enable Kitchen Display System (Order Status)',
    kdsEnabledInfo: 'When enabled, the Order Status / KDS screen is accessible from the main navigation. Disable to hide it from all users.',
    key: 'Key',
    kids: 'Kids Menu',
    kilograms: 'kg',
    kitchen: 'Kitchen',
    kitchenAlert: 'Kitchen alert',
    kitchenDisplay: 'Kitchen Display',
    kitchenDisplaySettings: 'Kitchen Display System',
    kitchenError: 'Kitchen error',
    kitchenOutputMode: 'Kitchen Output Mode',
    kitchenOutputModeInfo: 'Display: KDS screen only. Tickets: print item tickets. Both: KDS + tickets. None: disabled.',
    language: 'Language',
    languageSettings: 'Language Settings',
    last: 'Last',
    lastActivity: 'Last Activity',
    lastMonth: 'Last Month',
    lastNames: 'Last Names',
    lastWeek: 'Last Week',
    lastYear: 'Last Year',
    layout: 'Layout',
    light: 'Light',
    lightTheme: 'Light',
    line: 'Line',
    liters: 'L',
    litersSold: 'Liters Sold',
    liveMode: 'Live (Real-time)',
    loading: 'Loading...',
    loadingAvailableOrders: 'Loading available orders...',
    loadingIepsData: 'Loading IEPS data',
    loadingInventory: 'Loading invoices',
    loadingProductions: 'Loading production runs',
    loadingSpecials: 'Loading specials',
    loadingThemes: 'Loading themes',
    localTime: 'Local Time',
    login: 'Login',
    loginButton: 'Login',
    loginSuccess: 'Login successful',
    loginTime: 'Login Time',
    logo: 'Logo',
    logout: 'Logout',
    logoutSuccess: 'Logout successful',
    lowercaseAlphanumericOnly: 'Lowercase letters, numbers, and underscores only',
    lowInk: 'Low Ink',
    lowStock: 'Low Stock',
    lowStockWarning: 'Low stock warning',
    loyalty: 'Loyalty Points',
    mainCourse: 'Main Course',
    make: 'Make',
    manager: 'Manager',
    mandatory: 'Mandatory',
    margin: 'Margin',
    markAsDontMake: 'Mark as Don\'t Make',
    markAsFeatured: 'Toggle featured',
    markAsMake: 'Mark as Make',
    maxFileSize: 'Maximum file size',
    maximize: 'Maximize',
    maximumLength: 'Maximum length',
    meat: 'Meat',
    menuAccentColor: 'Accent Color',
    menuBar: 'Menu Bar',
    menuBgColor: 'Background Color',
    menuColors: 'Menu Colors',
    menuColumns: 'Menu Columns',
    menuDisplayMode: 'Menu Display Mode',
    menuEnabled: 'Enable Digital Menu',
    menuEnabledInfo: 'Allow customers to view the restaurant menu by scanning a QR code.',
    menuFont: 'Menu Font',
    menuHeaderColor: 'Category Header Color',
    menuManagement: 'Menu Management',
    menuPreview: 'Menu Preview',
    menuSettings: 'Menu Settings',
    menuTextColor: 'Text Color',
    meters: 'm',
    metrics: 'Metrics',
    milliliters: 'ml',
    minimize: 'Minimize',
    minimumLength: 'Minimum length',
    minQuantity: 'Minimum Quantity',
    minutesAgo: 'minutes ago',
    mobileColumns: 'Mobile columns',
    modified: 'Modified',
    monday: 'Monday',
    month: 'Month',
    monthly: 'Monthly',
    monthlyAmount: 'Monthly Amount',
    monthlyCosts: 'Monthly Costs',
    monthlyCostsBreakdown: 'Monthly Costs Breakdown',
    monthlyProfit: 'Monthly Profit',
    monthlyRevenue: 'Monthly Revenue',
    monthlyRevenueBreakdown: 'Monthly Revenue Breakdown',
    monthlySales: 'Monthly Sales',
    monthlySummary: 'Monthly Summary',
    months: 'Months',
    mostExpensive: 'Most Expensive',
    moveSelected: 'Move Selected',
    moveTable: 'Move Table',
    moveTo: 'Move to...',
    moveToCheck: 'Move to Check',
    multipleAllowed: 'multiple allowed',
    multipleRegistersActive: 'Multiple cash registers are open. Please select which register this payment belongs to:',
    mustBe: 'must be',
    mustBe4Digits: 'must be exactly 4 digits',
    name: 'Name',
    nameDisplay: 'Name display',
    nameDisplayBoth: 'Group & category names',
    nameDisplayCategories: 'Category names only',
    nameDisplayGroups: 'Group names only',
    nameDisplayNone: 'No names',
    nameForSplitCheck: 'Name for Split Check',
    nameSpanish: 'Spanish Name',
    narrow: 'Narrow',
    networkError: 'Network error',
    new: 'New',
    newCheck: 'New Check',
    newGroup: 'New Group',
    newItem: 'New Item',
    newOrder: 'New Order',
    newOrders: 'New Orders',
    newOrderWillBeCreated: 'A new standalone order will be created for this invoice.',
    newTabName: 'New Tab Name',
    next: 'Next',
    no: 'No',
    noActiveRegisterError: 'No active cash register. Please open a register or choose a different payment method.',
    noActiveSessions: 'No active sessions',
    noApplicableSpecials: 'No applicable specials at this time',
    noCategories: 'No categories',
    noClosedSessions: 'No closed sessions found',
    noCostsAdded: 'No costs added yet',
    noCostsInCategory: 'No costs in this category',
    noData: 'No data available',
    noDiscount: 'No discount',
    noInventoryItemsFound: 'No invoices found',
    noInvoiceGenerated: 'No invoice generated',
    noInvoicesFound: 'No invoices found',
    noItems: 'No items',
    noItemsAssigned: 'No items assigned',
    noItemsInCheck: 'No items in this check',
    noItemsInOrder: 'No items in this order',
    noKitchenOutput: 'None',
    nonAlcoholic: 'Non-Alcoholic',
    none: 'None',
    noOrderIdProvided: 'No order ID provided',
    noOrdersFound: 'No orders found',
    noPastOrders: 'No past orders found',
    noPaymentRequired: 'No payment required',
    noPayouts: 'No payouts for this session',
    noPrinterSelected: 'No printer selected. Please select a printer when prompted.',
    noProductionRunsFound: 'No production runs found',
    noProductsFound: 'No products found',
    noResultsFound: 'No results found for',
    noSalesData: 'No sales data found for this period',
    noSpecialsFound: 'No specials found',
    notaDeRemision: 'Nota de Remisión',
    notApplicable: 'N/A',
    notAvailable: 'Not available',
    notCompatible: 'Not compatible',
    note: 'Note',
    notes: 'Notes',
    notesPlaceholder: 'Enter notes or special instructions...',
    notIncludedInMonthly: 'Not included in monthly calculations',
    noTip: 'No Tip',
    noTipConfirm: 'No tip has been entered. Continue without tip?',
    nutritionInfo: 'Nutrition Information',
    occupied: 'Occupied',
    oceanTheme: 'Ocean',
    of: 'of',
    offline: 'Offline',
    oneTime: 'One Time',
    onHold: 'On Hold',
    open: 'Open',
    openChecks: 'Open Checks',
    openChildrenTabs: 'Open children tabs',
    openDrawer: 'Open Drawer',
    opened: 'Opened',
    openedBy: 'Opened by',
    opening: 'Opening',
    openingCash: 'Opening Cash',
    openOrders: 'Open Orders',
    openRegister: 'Open Register',
    openRegisters: 'Open Registers',
    operationCompleted: 'Operation completed successfully',
    operationFailed: 'Operation failed',
    option: 'Option',
    optional: 'Optional',
    optionGroup: 'Option Group',
    optionGroups: 'Option Groups',
    optionManagement: 'Option Management',
    options: 'Options',
    order: 'order',
    orderCancelled: 'Order cancelled',
    orderClosedSuccessfully: 'Order closed successfully',
    orderCompleted: 'Order completed',
    orderCreated: 'Order created successfully',
    orderDelay: 'Order delay notification',
    orderDeleted: 'Order deleted successfully',
    orderDetails: 'Order Details',
    orderLabel: 'Order label',
    orderLabelPlaceholder: 'Name or number',
    orderLabelsEnabled: 'Order labels',
    orderLabelsEnabledInfo: 'Add a short label to an order. Each item keeps the label it was sent under.',
    orderManagement: 'Order Management',
    orderName: 'Order Name',
    orderNumber: 'Order #',
    orderReceived: 'Order Received',
    orderReopenedSuccessfully: 'Order reopened successfully',
    orders: 'Orders',
    ordersCombinedSuccessfully: 'Orders combined successfully',
    ordersOverTime: 'Orders Over Time',
    orderStatus: 'Order Status',
    orderSummary: 'Order Summary',
    orderTime: 'Order Time',
    orderTotal: 'Total',
    orderType: 'Order Type',
    orderUpdated: 'Order updated successfully',
    ordinal: 'Ordinal',
    organic: 'Organic',
    originalCheck: 'Original Check',
    other: 'Other',
    otherNotSpecified: 'Other / Not Specified',
    otherPayment: 'Other Payment',
    ounces: 'oz',
    ourMenu: 'Our Menu',
    outboundInvoices: 'Outbound Invoices',
    outOfStock: 'Out of Stock',
    outOfStockWarning: 'Item is out of stock',
    over: 'Over',
    overdue: 'Overdue',
    overtime: 'Overtime',
    overview: 'Overview',
    owner: 'Owner',
    paid: 'Paid',
    paperCut: 'Paper Cut',
    paperJam: 'Paper Jam',
    paperWidth: 'Paper Width',
    parentOrderId: 'Parent Order ID',
    partialCut: 'Partial cut',
    partialPaymentInfo: 'An amount smaller than the balance is recorded and the check stays open.',
    password: 'Password',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordTooShort: 'Password too short',
    pasta: 'Pasta',
    paste: 'Paste',
    pastHour: 'Past Hour',
    pastOrders: 'Past Orders',
    pastWeek: 'Past Week',
    patterns: 'Patterns',
    payment: 'Payment',
    paymentApproved: 'Payment Approved',
    paymentDueDays: 'Payment due within 15 days after delivery',
    paymentFailed: 'Payment Failed',
    paymentMethod: 'Payment Method',
    paymentReceived: 'Payment Received',
    paymentRecorded: 'Payment recorded',
    paymentsTaken: 'Payments Taken',
    paymentTerms: 'Payment Terms',
    payout: 'Payout',
    payoutDepositList: 'Payout/Deposit List',
    payoutDescription: 'Add description...',
    payoutList: 'Payout List',
    payoutManagement: 'Payout Management',
    payouts: 'Payouts',
    payoutType: 'Payout Type',
    pending: 'Pending',
    pendingApproval: 'Pending Approval',
    per: 'per',
    percentage: '%',
    percentageDiscount: 'Percentage Discount',
    performance: 'Performance',
    permissionRequired: 'Permission required',
    permissions: 'Permissions',
    pettyCash: 'Petty Cash',
    phone: 'Phone',
    phonePlaceholder: 'Enter phone number',
    photo: 'Photo',
    photosHowToBody: 'Upload a photo with the camera button next to each item, either here in Category Visibility or in Product Management. The photo only shows on the public menu when the item is also marked as featured with the star button.',
    photosHowToTitle: 'How photos work',
    photosSection: 'Photos',
    pieces: 'pieces',
    pin: 'PIN',
    pinsDoNotMatch: 'PINs do not match',
    pixels: 'pixels',
    pizza: 'Pizza',
    placeholder: 'Enter value...',
    pleaseCreateAtLeastOneSplitCheckWithANameAndItems: 'Please create at least one split check with a name and items',
    pleaseEnterANameForTheSplitCheck: 'Please enter a name for the split check',
    pleaseEnterValidDiscountAmount: 'Please enter a valid discount amount',
    pleaseProvideDetails: 'Please provide details',
    pleaseProvideDetailsForOther: 'Please provide details when selecting "Other" as the reason',
    pleaseProvideNamesForAllSplitChecksThatHaveItems: 'Please provide names for all split checks that have items',
    pleaseSelectAnOrderToCombineWith: 'Please select an order to combine with',
    pleaseSelectAtLeastOneItemToSplit: 'Please select at least one item to split',
    pleaseSelectFile: 'Please select a file',
    pleaseSelectItems: 'Please select at least one item',
    pleaseSelectReasonForDeletion: 'Please select a reason for deletion',
    pleaseSelectRegister: 'Please select a register',
    popular: 'Popular',
    portion: 'portion',
    portionSize: 'Portion Size',
    poultry: 'Poultry',
    pounds: 'lbs',
    pourSizeBreakdown: 'Pour Size Breakdown',
    precio: 'Price',
    preorderItems: 'Preorder Items',
    preparing: 'Preparing',
    prepTime: 'Prep Time',
    presentation: 'presentation',
    preview: 'Preview',
    price: 'Price',
    priceAdjust: 'Price Adjust',
    priceChangeWarning: 'Price has changed since order was placed',
    primary: 'Primary',
    primaryColor: 'Primary Color',
    print: 'Print',
    printAirprint: 'Print (AirPrint)',
    printDontMakeItems: 'Print "Don\'t Make" items on tickets',
    printDontMakeItemsInfo: 'When enabled, items marked as "Don\'t Make" will appear on printed tickets (marked as NO PREPARAR).',
    printer: 'Printer',
    printerConfiguration: 'Printer Configuration',
    printerManagement: 'Printer Management',
    printerMapping: 'Printer Mapping',
    printerMappingHelp: 'Select the device that corresponds to this printer',
    printError: 'Print error',
    printerSettings: 'Printer Settings',
    printerStatus: 'Printer Status',
    printerTestMode: 'Printer Test Mode',
    printerType: 'Printer Type',
    printing: 'Printing...',
    printInvoice: 'Print Invoice',
    printMode: 'Print Mode',
    printModeChangedTo: 'Print mode changed to',
    printPreview: 'Print Preview',
    printQueue: 'Print Queue',
    printReceipt: 'Print Receipt',
    printTest: 'Print Test',
    priority: 'Priority',
    processCardPayment: 'Process Card Payment',
    processing: 'Processing',
    processingPayment: 'Processing Payment',
    product: 'Product',
    productBeer: 'Product (Beer)',
    productCategory: 'Category',
    productCode: 'Product Code',
    productCreated: 'Product created successfully',
    productDeleted: 'Product deleted successfully',
    productDescription: 'Description',
    productDisplaySettings: 'Product Display Settings',
    productImage: 'Image',
    productionInProgress: 'In Progress',
    productManagement: 'Product Management',
    productName: 'Product Name',
    productPrice: 'Price',
    products: 'Products',
    productSalesProjections: 'Product Sales Projections',
    productsUsingCategory: 'product(s) are using it. Please reassign products first.',
    productUpdated: 'Product updated successfully',
    profit: 'Profit',
    profitByPeriod: 'Profit by Period',
    projections: 'Projections',
    projectionsOverview: 'Projections Overview',
    pt210Recommended28: 'For GOOJPRT PT210, 28 characters is recommended',
    published: 'Published',
    purchaseDate: 'Purchase Date',
    qrCodeGenerator: 'QR Code Generator',
    qrCodeText: 'QR Code Text',
    qrCodeUrl: 'QR Code URL',
    qty: 'Qty',
    quality: 'Quality',
    quantity: 'Quantity',
    quickLogin: 'Quick Login',
    quickOrder: 'Quick Order',
    quickTests: 'Quick Tests',
    ready: 'Ready',
    readyEnroute: 'Ready/Enroute',
    reasonForDeletion: 'Reason for deletion',
    receipt: 'Receipt',
    receiptFormat: 'Receipt Format',
    receiptNumber: 'Receipt Number',
    receiptsWillPrintAutomatically: 'Receipts will print automatically based on selected mode',
    receive: 'Receive',
    received: 'RECEIVED',
    receivedBy: 'Received By',
    receivedDate: 'Received Date',
    recibidoPor: 'Received By',
    recipient: 'Recipient',
    recipientName: 'Recipient name',
    recombine: 'Recombine',
    recombineCheck: 'Recombine Check',
    recombineSplitCheck: 'Recombine Split Check',
    recombineThisSplitCheckWithItsParent: 'Recombine this split check with its parent',
    recombineWarningMessage: 'This action will move all items from this split check back to the parent order. This split check will be deleted and cannot be undone.',
    recombining: 'Recombining...',
    recordPayment: 'Record Payment',
    records: 'Records',
    rectangle: 'Rectangle',
    redo: 'Redo',
    refresh: 'Refresh',
    RefreshData: 'Refresh Data',
    refund: 'Refund',
    refundConfirmation: 'Are you sure you want to process this refund?',
    register: 'Register',
    registerClosed: 'Register Closed',
    registerManagement: 'Register Management',
    registerOpened: 'Register Opened',
    reject: 'Reject',
    rejected: 'Rejected',
    remainingBalance: 'Remaining Balance',
    remove: 'Remove',
    removeItem: 'Remove Item',
    removePhoto: 'Remove photo',
    renovation: 'Renovation',
    rent: 'Rent',
    reopen: 'Reopen',
    reopening: 'Reopening',
    reopenOrder: 'Reopen Order',
    reorder: 'Re-order',
    reorderPoint: 'Reorder Point',
    reorderThisItem: 'Reorder this item',
    reports: 'Reports',
    required: 'Required',
    reserved: 'Reserved',
    reset: 'Reset',
    resetLogo: 'Reset to Default',
    resetToDefault: 'Reset to Default',
    resetToDefaults: 'Reset to Defaults',
    resetToDefaultsConfirmation: 'Are you sure you want to reset all printer settings to defaults?',
    restaurantConfiguration: 'Restaurant Configuration',
    restaurantSetup: 'Restaurant Setup',
    restoreData: 'Restore Data',
    results: 'Results',
    retryPayment: 'Retry Payment',
    returned: 'Returned',
    revenue: 'Revenue',
    revenueOverTime: 'Revenue Over Time',
    revenueVsCosts: 'Revenue vs Costs',
    role: 'Role',
    roleManagement: 'Role Management',
    round: 'Round',
    rush: 'Rush Order',
    safeDeposit: 'Safe Deposit',
    salad: 'Salad',
    salary: 'Salary',
    sales: 'Sales',
    salesAllTime: 'Sales - All Time',
    salesByCategory: 'Sales by Category',
    salesByGroup: 'Sales by Group',
    salesPerTable: 'Sales Per Table',
    salesProjections: 'Sales Projections',
    salesProjectionsDescription: 'Configure expected sales per product. Use either daily sales OR sales per table (not both).',
    salesReport: 'Sales Report',
    salesValue: 'Sales Value',
    salesYTD: 'Sales - Year to Date',
    saturday: 'Saturday',
    save: 'Save',
    saveBestSettings: 'Save your best settings after testing',
    saveChanges: 'Save changes?',
    saving: 'Saving...',
    scale: 'Scale',
    scanForPrinters: 'Scan for Printers',
    scanToViewMenu: 'Scan to view our menu',
    schedule: 'Schedule',
    seafood: 'Seafood',
    search: 'Search',
    searchCategories: 'Search Categories',
    searchInvoices: 'Search invoices...',
    searchOptionGroups: 'Search option groups...',
    searchOptions: 'Search options...',
    searchOrders: 'Search orders...',
    searchPlaceholder: 'Search...',
    searchProducts: 'Search products...',
    searchSessions: 'Search sessions...',
    searchSpecials: 'Search specials...',
    searchTables: 'Search tables...',
    searchUsers: 'Search users...',
    seasonal: 'Seasonal',
    seatingCapacity: 'Seating Capacity',
    secondary: 'Secondary',
    secondaryColor: 'Secondary Color',
    select: 'Select',
    selectAll: 'Select All',
    selectCategory: 'Select Category',
    selected: 'selected',
    selectedByDefault: 'Selected by Default',
    selectedItems: 'Selected Items',
    selectedOrder: 'Selected Order (Source)',
    selectFile: 'Select File',
    selectInsumo: 'Select Insumo',
    selectItemsToSplit: 'Select Items to Split',
    selectMonth: 'Select Month',
    selectMultiple: 'Select Multiple',
    selectNone: 'Select None',
    selectOption: 'Select an option',
    selectOptionGroup: 'Select Option Group',
    selectOrder: 'Select Order',
    selectProduct: 'Select Product',
    selectReason: 'Select a reason...',
    selectRegister: 'Select Register',
    selectRegisterSession: 'Select Register',
    selectTable: 'Select a table',
    selectThisDevice: 'Select This Device',
    selectTimeRange: 'Select Time Range',
    selectType: 'Select Type',
    selectUser: 'Select User',
    selectYear: 'Select Year',
    send: 'Send',
    sendOrder: 'Send Order',
    serialOnly: 'Serial only',
    served: 'Served',
    server: 'Server',
    serverError: 'Server error',
    serviceCharge: 'Service charge',
    serviceChargeEnabled: 'Service charge',
    serviceChargeEnabledInfo: 'Offer a service charge when closing a check. Turning it off hides the field; a charge already on an order is kept.',
    serviceChargeInfo: 'Added to the total alongside the tip.',
    serving: 'serving',
    servingTime: 'Serving Time',
    session: 'Session',
    sessionExpired: 'Session expired',
    sessionHistory: 'Session History',
    sessionId: 'Session ID',
    sessionManagement: 'Session Management',
    sessionSettings: 'Session Settings',
    sessionsRefreshAutomatically: 'Active sessions refresh automatically every 30 seconds',
    sessionTimeoutHours: 'Session Timeout Hours',
    setAsDefaultDark: 'Set as default dark theme',
    setAsDefaultLight: 'Set as default light theme',
    setDark: 'Set Dark',
    setLight: 'Set Light',
    setPin: 'Set your 4-digit PIN',
    settings: 'Settings',
    settingsReset: 'Settings reset to defaults',
    settingsSaved: 'Settings saved successfully',
    shape: 'Shape',
    shareAsPdf: 'Share as PDF',
    shift: 'Shift',
    shiftEnd: 'Shift End',
    shiftStart: 'Shift Start',
    shipped: 'Shipped',
    shippingAddress: 'Shipping Address',
    shippingAndHandling: 'Shipping & Handling',
    shippingCost: 'Shipping Cost',
    short: 'Short',
    showDeletedTables: 'Show deleted tables',
    showDetails: 'Click to show details',
    showInactiveProducts: 'Show Inactive Products',
    showInactiveSpecials: 'Show Inactive Specials',
    showInactiveUsers: 'Show inactive users',
    showing: 'Showing',
    showItem: 'Show item',
    showItemImages: 'Show item photos',
    showItemImagesHint: 'Show photos for items marked as featured. Disable to hide all photos site-wide without deleting them.',
    showMenuTitle: 'Show menu title',
    showOnMenu: 'Show on menu',
    showPastOrders: 'Show Past Orders',
    showPrintPreview: 'Show print preview',
    sidebar: 'Sidebar',
    sides: 'Sides',
    signature: 'Signature',
    size: 'Size',
    smallScreenColumns: 'Small screen columns',
    snapshotSaved: 'Snapshot saved',
    snapToGrid: 'Snap to Grid',
    sort: 'Sort',
    sortCategoriesAlphabetically: 'Sort Categories Alphabetically',
    sortCategoriesByDisplayOrder: 'Sort Categories by Display Order',
    sortItemsAlphabetically: 'Sort items alphabetically by name',
    sortItemsByDisplayOrder: 'Sort items by their assigned display order (ordinal)',
    sortOrderChangeInfo: 'Changes to sort order will take effect after refreshing the page',
    soundOff: 'Sound Off',
    soundOn: 'Sound On',
    soup: 'Soup',
    spanish: 'Español',
    specialApplied: 'Special applied successfully',
    specialCreated: 'Special created successfully',
    specialDeleted: 'Special deleted successfully',
    specialDescription: 'Description',
    specialInstructions: 'Special Instructions',
    specialName: 'Special Name',
    specials: 'Daily Specials',
    specialsAvailable: 'Specials Available',
    specialsManagement: 'Specials Management',
    specialType: 'Special Type',
    specialUpdated: 'Special updated successfully',
    spicy: 'Spicy',
    split: 'Split',
    splitAmount: 'Split Amount',
    splitBill: 'Split Bill',
    splitByItem: 'Split by Item',
    splitCheck: 'Split Check',
    splitCheckDetails: 'Split Check Details',
    splitCheckName: 'Split Check Name',
    splitChecks: 'Split Checks',
    splitCustom: 'Custom Split',
    splitEvenly: 'Split Evenly',
    splitIntoMultipleChecks: 'Split into multiple checks',
    splitItem: 'Split Item',
    splitPaymentsEnabled: 'Split payments',
    splitPaymentsEnabledInfo: 'Record more than one payment against a bill, each with its own method and tip.',
    splitThisCheck: 'Split this check',
    splitting: 'Splitting...',
    splitWarning: 'This action will create separate checks. Make sure to review the items before proceeding.',
    staff: 'Staff',
    staffPayment: 'Staff Payment',
    staffReport: 'Staff Report',
    startDate: 'Start Date',
    staticMode: 'Static (Snapshot)',
    status: 'Status',
    statusBar: 'Status Bar',
    stockLevel: 'Stock Level',
    submit: 'Submit',
    subtotal: 'Subtotal',
    success: 'Success',
    successColor: 'Success Color',
    successfullyExportedOrderItems: 'Successfully exported {count} order items to {filename}',
    successfullyImported: 'Successfully imported {count} out of {total} items',
    sunday: 'Sunday',
    supplier: 'Supplier',
    surface: 'Surface',
    surfaceColor: 'Surface Color',
    systemMaintenance: 'System maintenance scheduled',
    SystemSettings: 'System Settings',
    systemSettings: 'System Settings',
    table: 'Table',
    tableArea: 'Table Area',
    tableAreas: 'Table areas',
    tableAreasEnabled: 'Table areas',
    tableAreasEnabledInfo: 'Split the floor plan into named zones and assign each table to one.',
    tableCreated: 'Table created successfully',
    tableDeleted: 'Table deleted successfully',
    tableLayout: 'Table Layout',
    tableManagement: 'Table Management',
    tableName: 'Table Name',
    tableNumber: 'Table #',
    tablePosition: 'Table Position',
    tables: 'Tables',
    tablesManagement: 'Tables Management',
    tablespoons: 'tbsp',
    tableStatus: 'Status',
    tableUpdated: 'Table updated successfully',
    tabs: 'Tabs',
    takeOut: 'Take Out',
    takeSnapshot: 'Take Snapshot',
    tax: 'Tax',
    taxId: 'Tax ID',
    taxRate: 'Tax rate',
    taxRateInfo: 'Percent of IVA included in every price. Used by receipts, tickets and invoices.',
    team: 'Team',
    teaspoons: 'tsp',
    temperature: 'Temperature',
    terminal: 'Terminal',
    test: 'Test',
    testModeOnly: 'Test Mode Only',
    testSections: 'Test Sections',
    text: 'Text',
    textColor: 'Text Color',
    textLight: 'Text Light',
    textLightColor: 'Text Light Color',
    textSecondary: 'Text Secondary',
    textSecondaryColor: 'Text Secondary Color',
    theme: 'Theme',
    themeManagement: 'Theme Management',
    themeName: 'Theme Name',
    themes: 'Themes',
    thermalPrinter: 'Thermal Printer',
    thermalPrinterControls: 'Thermal Printer Controls',
    thermalPrinterOnly: 'Thermal printer only',
    thisMonth: 'This Month',
    thisNameAlreadyExists: 'This name already exists',
    thisOrderDoesNotHaveAParentToRecombineWith: 'This order does not have a parent to recombine with',
    thisWeek: 'This Week',
    thisYear: 'This Year',
    thursday: 'Thursday',
    ticketsOnly: 'Tickets Only',
    time: 'Time',
    timeIn: 'Time In',
    timeOut: 'Time Out',
    timePeriod: 'Time Period',
    timeRange: 'Time Range',
    timestamp: 'Timestamp',
    timeToFinish: 'Time to finish',
    timezoneInfo: 'Timezone for all time-related operations',
    tip: 'Tip',
    tipAmount: 'Tip Amount',
    tippedOrders: 'Orders With Tip',
    tipPercentage: 'Tip Percentage',
    tips: 'Tips',
    tipsByPaymentMethod: 'Tips by Payment Method',
    tipsByServer: 'Tips by Server',
    tipsOverTime: 'Tips Over Time',
    tipsReport: 'Tips Report',
    today: 'Today',
    toDisplay: 'to display',
    tomorrow: 'Tomorrow',
    toolbar: 'Toolbar',
    topSelling: 'Top Selling',
    total: 'Total',
    totalBeingRecombined: 'Total Being Recombined',
    totalItems: 'total items',
    totalLitersSold: 'Total Liters Sold',
    totalMonthlyCosts: 'Total Monthly Costs',
    totalMonthlyRevenue: 'Total Monthly Revenue',
    totalPayouts: 'Total Payouts',
    totalRegisters: 'Total Registers',
    totalRevenue: 'Total Revenue',
    totals: 'Totals',
    totalSalesValue: 'Total Sales Value',
    totalServings: 'Total Servings',
    totalShifts: 'Total Shifts',
    totalTables: 'Total Tables',
    totalTips: 'Total Tips',
    totalToPay: 'Total to Pay',
    transactionHistory: 'Transaction History',
    transactions: 'Transactions',
    tryQuickTests: 'Try the quick test buttons first to find the best width for your printer',
    tuesday: 'Tuesday',
    unassigned: 'Unassigned',
    unassignedCategories: 'Unassigned Categories',
    uncategorized: 'Uncategorized',
    undo: 'Undo',
    unexpectedError: 'Unexpected error',
    ungroup: 'Ungroup',
    ungrouped: 'Ungrouped',
    units: 'Units',
    unitsSold: 'Units Sold',
    unknown: 'Unknown',
    unknownError: 'Unknown error',
    unknownOther: 'Unknown/Other',
    unnamedItem: 'Unnamed Item',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
    update: 'Update',
    updated: 'Updated',
    updateUser: 'Update User',
    upload: 'Upload',
    uploadLogo: 'Upload',
    upTo: 'up to',
    usbSerialPrinter: 'USB/Serial Printer',
    useChromeEdgeForThermalPrinters: 'Use Chrome/Edge 89+ for USB/Serial thermal printers',
    useExistingOrder: 'Use Existing Order',
    usePrintTestToVerifyConnection: 'Use "Print Test" to verify connection',
    user: 'User',
    userCreated: 'User created successfully',
    userDeleted: 'User deleted successfully',
    userInactive: 'User account is inactive. Please contact an administrator.',
    userManagement: 'User Management',
    username: 'Username',
    users: 'Users',
    usersManagement: 'Users Management',
    userUpdated: 'User updated successfully',
    usingDefaultLogo: 'Using default BOCA logo',
    utilities: 'Utilities',
    validationError: 'Validation error',
    vegan: 'Vegan',
    vegetarian: 'Vegetarian',
    view: 'View',
    viewDiagnostics: 'View Diagnostics',
    viewInvoice: 'View Invoice',
    voidPaymentConfirmation: 'Are you sure you want to void this payment?',
    voidTransaction: 'Void Transaction',
    waiter: 'Waiter',
    waitress: 'Waitress',
    warning: 'Warning',
    warningColor: 'Warning Color',
    webBluetoothApi: 'Web Bluetooth API',
    webSerialApi: 'Web Serial API',
    webSerialApiNotCompatible: 'Web Serial API not compatible',
    wednesday: 'Wednesday',
    weeklySummary: 'Weekly Summary',
    welcomeBack: 'Welcome back',
    wide: 'Wide',
    width: 'Width',
    widthHeightMustBe: 'Width/Height must be',
    with: 'with',
    without: 'without',
    withTip: 'With Tip',
    wrongOrder: 'Wrong order',
    yearly: 'Yearly',
    yearlyReport: 'Yearly Report',
    yes: 'Yes',
    yesterday: 'Yesterday',
  },
  es: {
    accessDenied: 'Acceso denegado',
    actions: 'Acciones',
    active: 'Activo',
    activeSessions: 'Sesiones Activas',
    activeSessionsManagement: 'Gestión de Sesiones Activas',
    actual: 'Real',
    actualCash: 'Efectivo Real',
    aCuentaDe: 'A cuenta de',
    add: 'Agregar',
    addArea: 'Agregar área',
    addCategory: 'Agregar Categoría',
    addCheck: 'Agregar Cuenta',
    addComboItem: 'Agregar Artículo',
    addGroup: 'Agregar Grupo',
    addItem: 'Agregar Artículo',
    addItems: 'Agregar Artículos',
    addNewCategory: 'Agregar Nueva Categoría',
    addNewCost: 'Agregar Nuevo Costo',
    addNewInventoryItem: 'Agregar Nuevo Artículo de Inventario',
    addNewSpecial: 'Agregar Nueva Promoción',
    addNewTheme: 'Agregar Nuevo Tema',
    addNewUser: 'Agregar Nuevo Usuario',
    addNotesAboutShift: 'Agregar notas sobre este turno...',
    addOrder: 'Agregar Orden',
    addPhoto: 'Agregar foto',
    addProduct: 'Agregar Producto',
    addProductionRun: 'Agregar Corrida',
    addProducts: 'Agregar Productos',
    address: 'Dirección',
    addressPlaceholder: 'Ingrese dirección',
    addSpecial: 'Agregar Promoción',
    addTab: 'Agregar Cuenta',
    addTable: 'Agregar Mesa',
    addTheme: 'Agregar Tema',
    addTip: 'Agregar Propina',
    addUser: 'Agregar Usuario',
    admin: 'Administrador',
    adminDashboardTabs: 'Pestañas del Panel de Administración',
    administration: 'Administración',
    adminLayout: 'Diseño del Panel',
    adminLayoutInfo: 'Arrastra secciones entre pestañas para reorganizar. Cambia la visibilidad con el icono del ojo.',
    advancedAnalytics: 'Análisis Avanzado',
    afterDiscount: 'después del descuento',
    ago: 'hace',
    alcoholic: 'Alcohólico',
    alignment: 'Alineación',
    all: 'Todos',
    allAreas: 'Todas las áreas',
    allCategories: 'Todas las Categorías',
    allergens: 'Alérgenos',
    allergyInfo: 'Información de Alergias',
    allGroups: 'Todos los Grupos',
    allOrders: 'Todas las Órdenes',
    allowedFormats: 'Formatos permitidos',
    allProducts: 'Todos los Productos',
    allRegisters: 'Todas las Cajas',
    allTime: 'Todo el Tiempo',
    alphabeticalOrder: 'Orden Alfabético',
    amount: 'Cantidad',
    analysis: 'Análisis',
    analytics: 'Análisis',
    analyze: 'Analizar',
    analyzing: 'Analizando',
    and: 'y',
    anOpenOrderWithThisNameAlreadyExists: 'Ya existe una orden abierta con este nombre para esta mesa.',
    anticipo: 'Anticipo',
    appetizer: 'Aperitivo',
    appliesTo: 'Aplica A',
    apply: 'Aplicar',
    applyChanges: 'Aplicar Cambios',
    applyDiscount: 'Aplicar Descuento',
    applying: 'Aplicando...',
    applySpecial: 'Aplicar Promoción',
    approve: 'Aprobar',
    approved: 'Aprobado',
    approvedBy: 'Aprobado por',
    approvedPayouts: 'Pagos Aprobados',
    archived: 'Archivado',
    area: 'Área',
    areaName: 'Nombre del área',
    areYouSureDeleteItemCannotUndo: '¿Estás seguro de que quieres eliminar este artículo? Esta acción no se puede deshacer.',
    assignItems: 'Asignar Artículos',
    assignItemsToSplitChecks: 'Asignar Artículos a Cuentas Divididas',
    attemptsRemaining: 'intentos restantes',
    authorizationCode: 'Codigo de Autorizacion',
    auto: 'Auto',
    automaticThermalToBrowser: 'Automático (térmica → navegador)',
    autoUsesDesktopFallback: 'Auto: usa mín(escritorio, 2)',
    availability: 'Disponibilidad',
    available: 'Disponible',
    average: 'Promedio',
    averageActiveTablesPerDay: 'Promedio de Mesas Activas por Día',
    averagePricePerLiter: 'Precio Promedio por Litro',
    avgFinishTime: 'Tiempo Promedio de Finalización',
    avgOrderTotal: 'Promedio por Orden',
    avgOrderTotalOverTime: 'Promedio por Orden en el Tiempo',
    avgTipPerOrder: 'Propina Promedio por Orden',
    back: 'Atrás',
    background: 'Fondo',
    backgroundColor: 'Color de Fondo',
    backupCreated: 'Respaldo creado exitosamente',
    backupData: 'Respaldar Datos',
    BackupDatabase: 'Respaldar Base de Datos',
    backupDescription: 'Descargue un respaldo completo de la base de datos de su restaurante',
    backupFailed: 'Error en el respaldo',
    backupInProgress: 'Creando respaldo...',
    bankTransfer: 'Transferencia Bancaria',
    bar: 'Bar',
    barcode: 'Código de Barras',
    barcodescanner: 'Escáner de Código de Barras',
    bartender: 'Cantinero',
    baud: 'baudios',
    baudRate: 'Velocidad de Baudios',
    beerProduction: 'Producción de Cerveza',
    beerProductionRuns: 'Corridas de Producción',
    beerSales: 'Ventas de Cerveza',
    beforeDiscount: 'antes del descuento',
    beverage: 'Bebida',
    billingAddress: 'Dirección de Facturación',
    bluetoothAlternative: 'O usa el navegador Bluefy para impresion Bluetooth',
    bluetoothPrinter: 'Impresora Bluetooth',
    border: 'Borde',
    borderColor: 'Color de Borde',
    break: 'Descanso',
    breakEvenDays: 'Punto de Equilibrio (Días)',
    browserCompatibility: 'Compatibilidad del Navegador',
    browserOnly: 'Solo navegador',
    browserPrinting: 'Impresión del navegador',
    browserPrintingWillStillWork: 'La impresión del navegador seguirá funcionando',
    businessName: 'Nombre del Negocio',
    busser: 'Ayudante de Mesa',
    buyQuantity: 'Cantidad para Comprar',
    buyXGetYFree: 'Compra X Lleva Y Gratis',
    byCategory: 'Por Categoría',
    byDay: 'Por Día',
    byGroup: 'Por Grupo',
    byHour: 'Por Hora',
    byMonth: 'Por Mes',
    byUser: 'Por Usuario',
    byWeek: 'Por Semana',
    byYear: 'Por Año',
    calculation: 'Cálculo',
    calories: 'Calorías',
    cancel: 'Cancelar',
    cancelled: 'Cancelado',
    cancelOrderConfirmation: '¿Estás seguro de que quieres cancelar esta orden?',
    cannotCloseParentTab: 'No se puede cerrar: Esta mesa tiene órdenes hijas abiertas',
    cannotDeleteAdminUser: 'No se puede eliminar el usuario administrador',
    cannotDeleteCategory: 'No se puede eliminar la categoría',
    cannotDeleteDefaultThemes: 'No se pueden eliminar temas predeterminados',
    cannotForceLogoutSelf: 'No puedes forzar el cierre de sesión de tu propia sesión',
    cantidad: 'Cantidad',
    canvasHeight: 'Alto del Lienzo',
    canvasWidth: 'Ancho del Lienzo',
    card: 'Tarjeta',
    cardCharge: 'Cargo a Tarjeta',
    cardholderName: 'Nombre del Titular',
    cardNumber: 'Numero de Tarjeta',
    cardPaymentProcessed: 'Pago con tarjeta procesado exitosamente',
    cash: 'Efectivo',
    cashCount: 'Conteo de Efectivo',
    cashDrawer: 'Cajón de Dinero',
    cashier: 'Cajero',
    cashReceived: 'Efectivo Recibido',
    cashSales: 'Ventas en Efectivo',
    categories: 'Categorías',
    category: 'Categoría',
    categoryBreakdown: 'Desglose por Categoría',
    categoryCreated: 'Categoría creada exitosamente',
    categoryDeleted: 'Categoría eliminada exitosamente',
    categoryManagement: 'Gestión de Categorías',
    categoryName: 'Nombre de Categoría',
    categorySortOrder: 'Orden de Categorías',
    categorySortOrderChangeInfo: 'Esta configuración controla el orden en que aparecen las categorías en la pantalla de selección de productos',
    categoryUpdated: 'Categoría actualizada exitosamente',
    categoryVisibility: 'Visibilidad y Orden de Categorías/Productos',
    celsius: '°C',
    centimeters: 'cm',
    cervezasGibbons: 'Cervezas Gibbons',
    change: 'Cambio',
    changeInSystemSettings: 'Esto se puede cambiar en Configuración del Sistema',
    changeLanguage: 'Cambiar Idioma',
    changeOwed: 'Cambio a Devolver',
    changePassword: 'Cambiar contraseña',
    changePin: 'Cambiar NIP',
    changesSaved: 'Cambios guardados exitosamente',
    characterLimit: 'Límite de caracteres',
    charged: 'Cobrado',
    chars: 'caracteres',
    chartPlaceholder: 'Implementación de gráficos próximamente',
    chartVisualization: 'Visualización de Gráficos',
    cheapest: 'Más Barato',
    check: 'Cuenta',
    checkName: 'Nombre de Cuenta',
    checkPrinterOutput: 'Verifique la salida de la impresora',
    checkRecombinedSuccessfully: 'Cuenta recombinada exitosamente',
    chef: 'Chef',
    chooseFile: 'Seleccionar archivo',
    clear: 'Limpiar',
    clearAllItems: 'Limpiar Todos los Artículos',
    clearAllItemsConfirm: '¿Está seguro de que desea archivar todos los artículos? Esto moverá todos los artículos en "Nuevos Pedidos", "En Progreso" y "Terminados" al estado archivado.',
    clearAllItemsSuccess: 'Todos los artículos han sido archivados',
    clickConnectPrinterAndSelectPort: 'Haga clic en "Conectar Impresora" y seleccione el puerto',
    clickToFinish: 'Haga clic para finalizar',
    clickToRemove: 'Haga clic para eliminar',
    clickToStart: 'Haga clic para iniciar',
    clickToViewDetails: 'Haga clic para ver detalles',
    close: 'Cerrar',
    closeCheck: 'Cerrar Cuenta',
    closed: 'Cerrada',
    closedBy: 'Cerrado Por',
    closedChecks: 'Cuentas Cerradas',
    closedOrders: 'Órdenes Cerradas',
    closedRegisters: 'Cajas Cerradas',
    closeOrderConfirmation: '¿Estás seguro de que quieres cerrar esta orden?',
    closeRegister: 'Cerrar Caja',
    closeThisCheck: 'Cerrar esta cuenta',
    closing: 'Cerrando',
    closingCash: 'Efectivo Final',
    collapse: 'Contraer',
    colorScheme: 'Esquema de Colores',
    columns: 'Columnas',
    combine: 'Combinar',
    combineCheck: 'Combinar Cuenta',
    combineChecks: 'Combinar Cuentas',
    combinedTotal: 'Total Combinado',
    combineOrders: 'Combinar Órdenes',
    combineThisCheckWithAnotherCheck: 'Combinar esta cuenta con otra cuenta',
    combineWarning: 'Esta acción moverá todos los artículos de la orden origen a la orden destino. La orden origen será eliminada y esta acción no se puede deshacer.',
    combineWarningMessage: 'Esta acción moverá todos los artículos de la orden seleccionada a la orden actual. La orden seleccionada será eliminada y no se puede deshacer.',
    combining: 'Combinando...',
    comboDeal: 'Oferta Combo',
    comboExample: 'Ejemplo',
    comboItems: 'Artículos del Combo',
    comboPrice: 'Precio del Combo',
    commission: 'Comisión',
    compatible: 'Compatible',
    completed: 'Completado',
    complimentaryOrder: 'Orden Cortesía',
    conditions: 'Condiciones',
    configure: 'Configurar',
    confirm: 'Confirmar',
    confirmCloseEmptyCheck: '¿Estás seguro de que quieres cerrar esta cuenta vacía?',
    confirmDelete: '¿Está seguro que desea eliminar este pago',
    confirmDeleteArea: '¿Eliminar esta área?',
    confirmDeleteInventoryItem: '¿Está seguro de que desea eliminar este artículo de inventario?',
    confirmDeleteProduction: '¿Está seguro que desea eliminar esta corrida de producción?',
    confirmDeleteSpecial: '¿Está seguro de que desea eliminar esta promoción?',
    confirmDeleteTheme: '¿Está seguro de que desea eliminar este tema?',
    confirmForceLogout: '¿Estás seguro de que quieres forzar el cierre de sesión de este usuario?',
    confirmItemDeletion: 'Confirmar Eliminación de Artículo',
    confirmLeaveWithPreorderItems: 'Tiene artículos sin enviar en preorden. ¿Está seguro de que desea salir?',
    confirmLogout: 'Esta seguro que quiere cerrar sesion?',
    confirmPin: 'Confirmar PIN',
    confirmReopenOrder: '¿Estás seguro de que quieres reabrir este pedido?',
    connected: 'Conectada',
    connecting: 'Conectando...',
    connectionFailed: 'Conexión falló. Por favor verifica que la impresora esté conectada y encendida.',
    connectionLost: 'Conexión perdida',
    connectionRestored: 'Conexión restaurada',
    connectPrinter: 'Conectar Impresora',
    connectThermalPrinterUsb: 'Conecte su impresora térmica por USB',
    contains: 'Contiene',
    continueWithoutTip: 'Continuar Sin Propina',
    cooking: 'Cocinando',
    cookingInstructions: 'Instrucciones de Cocción',
    cookTime: 'Tiempo de Cocción',
    copy: 'Copiar',
    cost: 'Costo',
    costManagement: 'Gestión de Costos',
    costName: 'Nombre del Costo',
    costoDeEnvio: 'Costo de Envío',
    costPerUnit: 'Costo/Unidad',
    coupon: 'Cupón',
    create: 'Crear',
    created: 'Creado',
    createdBy: 'Creado por',
    createDeposit: 'Agregar Depósito',
    createInvoice: 'Crear Factura',
    createNewOrder: 'Crear Nuevo Pedido',
    createOrder: 'Crear Orden',
    createPayout: 'Crear Pago',
    createSplitChecks: 'Crear Cuentas Divididas',
    creating: 'Creando',
    creatingSplitChecks: 'Creando Cuentas Divididas...',
    Credentials: 'Credenciales',
    creditCard: 'Tarjeta de Crédito',
    creditDebit: 'Crédito/Débito',
    creditDebitCard: 'Tarjeta de Crédito/Débito',
    creditTips: 'Propinas de Tarjeta',
    criteria: 'Criterios',
    crossMidnightTimeNote: 'Se admiten horarios que cruzan medianoche (ej: 22:00 a 02:00 para promociones nocturnas)',
    crypto: 'Criptomonedas',
    cups: 'tazas',
    currency: '$',
    currentDetails: 'Detalles Actuales',
    currentDiscount: 'Descuento Actual',
    currentOrder: 'Orden Actual (Destino)',
    currentUser: 'Usuario Actual',
    customer: 'Cliente',
    customerAddress: 'Dirección del Cliente',
    customerChangedMind: 'Cliente cambió de opinión',
    customerCity: 'Ciudad',
    customerComplaint: 'Queja del cliente',
    customerName: 'Nombre del Cliente',
    customerPhone: 'Teléfono del Cliente',
    customerState: 'Estado',
    customerZip: 'Código Postal',
    customItem: 'Artículo personalizado',
    customItemAdd: 'Agregar un artículo personalizado a esta categoría',
    customItemName: 'Nombre',
    customItemNamePlaceholder: 'Artículo que no está en el menú',
    customItemNameRequired: 'Escribe un nombre para el artículo personalizado',
    customItemPrice: 'Precio',
    customItemPriceRequired: 'Escribe un precio de cero o más',
    customItemQuantity: 'Cantidad',
    customItemQuantityRequired: 'Escribe una cantidad de al menos 1',
    customItemsEnabled: 'Habilitar artículos personalizados',
    customItemsEnabledInfo: 'Agrega un botón de artículo personalizado a cada categoría en la pantalla de orden, para vender algo que no está en el menú con un nombre y precio escritos en caja.',
    customItemsUsingCategory: 'hay órdenes pasadas con artículos personalizados vendidos en esta categoría',
    customName: 'Su nombre personalizado:',
    customTheme: 'Tema Personalizado',
    customTip: 'Propina Personalizada',
    cut: 'Cortar',
    cvv: 'CVV',
    daily: 'Diario',
    dailyAutoLogout: 'Cierre de Sesión Automático Diario',
    dailyAutoLogoutAt: 'Cierre de sesión automático a las',
    dailyAutoLogoutDisabled: 'El cierre de sesión automático diario está desactivado',
    dailyAutoLogoutEnabled: 'Cierre de Sesión Automático Diario Activado',
    dailyAutoLogoutInfo: 'Todas las sesiones se cierran automáticamente todos los días a las 5:00 AM',
    dailyLogoutHour: 'Hora de Cierre Diario',
    dailyLogoutMinute: 'Minuto de Cierre Diario',
    dailyLogoutTimezone: 'Zona Horaria de Cierre Diario',
    dailyOperations: 'Operaciones Diarias',
    dailySales: 'Ventas Diarias',
    dailySummary: 'Resumen Diario',
    dark: 'Oscuro',
    darkTheme: 'Oscuro',
    dashboard: 'Panel Principal',
    dataBackupReminder: 'Recordatorio de respaldo de datos',
    dataExported: 'Datos exportados exitosamente',
    dataImported: 'Datos importados exitosamente',
    dataRestored: 'Datos restaurados exitosamente',
    date: 'Fecha',
    dateRange: 'Rango de Fechas',
    datetime: 'Fecha y Hora',
    dayOfWeek: 'Día de la Semana',
    days: 'días',
    daysAgo: 'hace días',
    daysLabel: 'días',
    daysOfWeek: 'Días de la Semana',
    daysOpenInMonth: 'Días Abiertos en el Mes',
    debitCard: 'Tarjeta de Débito',
    decreaseQuantity: 'Disminuir cantidad',
    default: 'Predeterminado',
    defaultDark: 'Predeterminado Oscuro',
    defaultLight: 'Predeterminado Claro',
    defaultSales: 'ventas predeterminadas',
    defaultStartupMode: 'Modo de Inicio Predeterminado',
    defineShiftTimes: 'Definir Horarios de Turno',
    delayed: 'Retrasado',
    delete: 'Eliminar',
    deleteArea: 'Eliminar área',
    deleteCategory: 'Eliminar Categoría',
    deleteConfirmation: '¿Estás seguro de que quieres eliminar este elemento?',
    deleted: 'Eliminado',
    deleteGroup: 'Eliminar Grupo',
    deleteItem: 'Eliminar Artículo',
    deleteOrder: 'Eliminar Orden',
    deleteOrderConfirmation: '¿Estás seguro de que quieres eliminar esta orden? Esta acción no se puede deshacer.',
    deleteProduct: 'Eliminar Producto',
    deleteProductConfirmation: '¿Estás seguro de que quieres eliminar este producto? Esta acción no se puede deshacer.',
    deleteSpecial: 'Eliminar Promoción',
    deleteTable: 'Eliminar Mesa',
    deleteTableConfirmation: '¿Estás seguro de que quieres eliminar esta mesa? Esta acción no se puede deshacer.',
    deleteUser: 'Eliminar usuario',
    deleting: 'Eliminando...',
    delivered: 'Entregado',
    deliveredBy: 'Entregado Por',
    delivery: 'Entrega a Domicilio',
    deliveryNote: 'Nota de Remisión',
    deposit: 'Depósito',
    depositDescription: 'ej., Depósito bancario, efectivo de ventas...',
    depositInfo: 'Agregar efectivo a la caja (ej., hacer cambio, agregar efectivo del banco)',
    deposits: 'Depósitos',
    descripcion: 'Descripción',
    deselectAll: 'Deseleccionar Todo',
    desktopColumns: 'Columnas escritorio',
    dessert: 'Postre',
    deviceIdentifier: 'Dispositivo',
    devLogin: 'Acceso Desarrollador',
    difference: 'Diferencia',
    digitalMenu: 'Menú Digital',
    digitalMenuUrl: 'URL del Menú Digital',
    digits: 'dígitos',
    dineIn: 'Comer Aquí',
    direccionDeEnvio: 'Dirección de envío',
    disabled: 'Deshabilitado',
    disableDailyLogout: 'Desactivar Cierre Diario',
    disableMovement: 'Deshabilitar Movimiento',
    discardChanges: '¿Descartar cambios?',
    disconnect: 'Desconectar',
    disconnected: 'Desconectada',
    disconnecting: 'Desconectando...',
    discount: 'Descuento',
    discountAmount: 'Cantidad de Descuento',
    discountByFixedAmount: 'Descuento por cantidad fija',
    discountByPercentage: 'Descuento por porcentaje',
    discountPercentage: 'Porcentaje de Descuento',
    discountPercentCannotExceed100: 'El porcentaje de descuento no puede exceder 100%',
    discountValue: 'Valor de Descuento',
    displayAndTickets: 'Pantalla + Tickets',
    displayOnly: 'Solo Pantalla',
    displayOrder: 'Orden de Visualización',
    dontMake: 'No Hacer',
    dontShowAgain: 'No mostrar esto de nuevo',
    download: 'Descargar',
    downloadBackup: 'Descargar Respaldo',
    downloadInvoice: 'Descargar Factura',
    downloadQrPdf: 'Descargar PDF del QR',
    dozen: 'docena',
    draft: 'Borrador',
    dragCategoriesBetweenGroups: 'Arrastra categorías entre grupos para organizarlas. Los cambios se guardan al hacer clic en Guardar.',
    dragCategoriesToAssignGroups: 'Las categorías se asignan automáticamente según los criterios. Edite los criterios para cambiar las asignaciones.',
    dragDropFile: 'Arrastre y suelte el archivo aquí',
    dragToAdjust: 'Arrastra los controles para ajustar el rango',
    dragToReorder: 'Arrastra para reordenar',
    dropCategoriesHere: 'Suelta categorías aquí',
    dueDate: 'Fecha de Vencimiento',
    duplicate: 'Duplicar',
    duplicateNameInSplitChecks: 'Nombre duplicado en cuentas divididas',
    duration: 'Duración',
    each: 'cada uno',
    earlierPaymentsKept: 'Los pagos ya registrados permanecen en esta cuenta.',
    edit: 'Editar',
    editCategory: 'Editar Categoría',
    editInventoryItem: 'Editar Artículo de Inventario',
    editItem: 'Editar artículo',
    editOrder: 'Editar Orden',
    editProduct: 'Editar Producto',
    editProductionRun: 'Editar Corrida',
    editSpecial: 'Editar Promoción',
    editTable: 'Editar Mesa',
    editTheme: 'Editar Tema',
    editUser: 'Editar usuario',
    email: 'Correo',
    emailPlaceholder: 'Ingrese dirección de email',
    emailReceipt: 'Enviar Recibo por Email',
    employee: 'Empleado',
    emptyCheck: 'Cuenta Vacía',
    enabled: 'Habilitado',
    enableDailyLogout: 'Activar Cierre Diario',
    enableMovement: 'Habilitar Movimiento',
    endDate: 'Fecha de Fin',
    english: 'English',
    enterDailySales: 'Ingrese ventas diarias',
    enterNameForTheSplitCheck: 'Ingresa nombre para la cuenta dividida...',
    enterNewPassword: 'Ingrese nueva contraseña',
    enterPin: 'Ingrese el PIN (4 dígitos)',
    enterSalesPerTable: 'Ingrese ventas por mesa',
    enterTabName: 'Ingrese nombre de cuenta',
    enterYourPin: 'Ingrese su PIN para continuar',
    entregadoPor: 'Entregado Por',
    error: 'Error',
    errorClosingOrder: 'Error cerrando orden',
    errorColor: 'Color de Error',
    errorConnectingPrinter: 'Error conectando impresora',
    errorDisconnectingPrinter: 'Error desconectando impresora',
    errorExportingInventory: 'Error al exportar artículos de inventario',
    errorExportingStatistics: 'Error al exportar estadísticas',
    errorFetchingTables: 'Error obteniendo mesas',
    errorImportingInventory: 'Error al importar artículos de inventario',
    errorInTest: 'Error en prueba',
    errorOpeningDrawer: 'Error abriendo cajón',
    errorRecombiningCheck: 'Error recombinando cuenta',
    exact: 'Exacto',
    excludeProducts: 'Excluir Productos',
    excludes: 'Excluye',
    exit: 'Salir',
    expand: 'Expandir',
    expected: 'Esperado',
    expectedCash: 'Efectivo Esperado',
    expedite: 'Expeditar',
    expenses: 'Gastos',
    expirationMonth: 'Mes de Expiracion',
    expirationYear: 'Ano de Expiracion',
    explainWhyItemNeedsDeleted: 'Explica por qué este artículo necesita ser eliminado...',
    export: 'Exportar',
    exportColCategoryArea: 'Área de Categoría',
    exportColCategoryName: 'Nombre de Categoría',
    exportColClosedBy: 'Cerrado Por',
    exportColDontMake: 'No Hacer',
    exportColFinishedDate: 'Fecha Terminada',
    exportColFinishedTime: 'Hora Terminada',
    exportColInProgressDate: 'Fecha En Progreso',
    exportColInProgressTime: 'Hora En Progreso',
    exportColItemCreatedDate: 'Fecha de Creación de Artículo',
    exportColItemCreatedTime: 'Hora de Creación de Artículo',
    exportColItemDiscount: 'Descuento de Artículo',
    exportColItemModifiedDate: 'Fecha de Modificación de Artículo',
    exportColItemModifiedTime: 'Hora de Modificación de Artículo',
    exportColItemNote: 'Nota de Artículo',
    exportColItemPrice: 'Precio de Artículo',
    exportColItemStatus: 'Estado de Artículo',
    exportColLineTotal: 'Total de Línea',
    exportColOpenedBy: 'Abierto Por',
    exportColOrderCreatedDate: 'Fecha de Creación de Orden',
    exportColOrderCreatedTime: 'Hora de Creación de Orden',
    exportColOrderedDate: 'Fecha Ordenada',
    exportColOrderedTime: 'Hora Ordenada',
    exportColOrderId: 'ID de Orden',
    exportColOrderModifiedDate: 'Fecha de Modificación de Orden',
    exportColOrderModifiedTime: 'Hora de Modificación de Orden',
    exportColOrderName: 'Nombre de Orden',
    exportColOrderProductId: 'ID de Producto de Orden',
    exportColOrderStatus: 'Estado de Orden',
    exportColOrderTip: 'Propina de Orden',
    exportColPaymentType: 'Tipo de Pago',
    exportColPrepTimeMinutes: 'Minutos Tiempo Preparación',
    exportColProductDescription: 'Descripción de Producto',
    exportColProductName: 'Nombre de Producto',
    exportColQuantity: 'Cantidad',
    exportColTableName: 'Nombre de Mesa',
    exportColTotalTimeMinutes: 'Minutos Tiempo Total',
    exportColumns: 'Columnas',
    exportColWaitTimeMinutes: 'Minutos Tiempo Espera',
    exporting: 'Exportando',
    exportLanguage: 'Idioma de Exportación',
    exportReport: 'Exportar Reporte',
    exportReports: 'Exportar Reportes',
    exportSettings: 'Configuración de Exportación',
    fahrenheit: '°F',
    failedToApplyDiscount: 'Error al aplicar descuento',
    failedToCancelItem: 'Error al cancelar artículo',
    failedToCloseOrder: 'Error al cerrar orden',
    failedToCreateOrder: 'Error al crear orden',
    failedToDeleteArea: 'No se pudo eliminar el área',
    failedToDeleteEmptyOrderButItemsMovedSuccessfully: 'Error al eliminar orden vacía, pero los artículos se movieron exitosamente',
    failedToDeleteEmptySplitCheckOrderButItemsMovedSuccessfully: 'Error al eliminar orden de cuenta dividida vacía, pero los artículos se movieron exitosamente',
    failedToDeleteInventoryItem: 'Error al eliminar artículo de inventario',
    failedToDeleteProduction: 'Error al eliminar corrida de producción',
    failedToDeleteSpecial: 'Error al eliminar promoción',
    failedToDeleteTheme: 'Error al eliminar tema',
    failedToFetchCurrentOrderData: 'Error al obtener datos de orden actual',
    failedToFetchExportData: 'Error al obtener datos de exportación',
    failedToFetchIepsData: 'Error al obtener datos IEPS',
    failedToFetchInventory: 'Error al obtener inventario',
    failedToFetchProductions: 'Error al cargar corridas de producción',
    failedToFetchSpecials: 'Error al obtener promociones',
    failedToFetchThemes: 'Error al obtener temas',
    failedToLoadAreas: 'No se pudieron cargar las áreas',
    failedToLoadAvailableOrders: 'Error al cargar órdenes disponibles',
    failedToLoadPayouts: 'Error al cargar pagos',
    failedToMoveItemToCurrentOrder: 'Error al mover artículo a la orden actual',
    failedToMoveItemToParentCheck: 'Error al mover artículo a la cuenta padre',
    failedToSaveArea: 'No se pudo guardar el área',
    failedToSaveInventoryItem: 'Error al guardar artículo de inventario',
    failedToSaveProduction: 'Error al guardar corrida de producción',
    failedToSaveSpecial: 'Error al guardar promoción',
    failedToSaveTheme: 'Error al guardar tema',
    failedToUpdateOrder: 'Error al actualizar orden',
    featured: 'Destacado',
    featureSettings: 'Configuración de Funciones',
    fecha: 'Fecha',
    feet: 'pies',
    fieldRequired: 'Este campo es requerido',
    filter: 'Filtrar',
    filterByCategory: 'Filtrar por Categoría',
    finalTotal: 'Total Final',
    financeInvoicing: 'Finanzas y Facturación',
    finishDate: 'Fecha de Finalización',
    finished: 'Terminado',
    firma: 'Firma',
    first: 'Primero',
    firstNames: 'Nombres',
    fixedDiscount: 'Descuento Fijo',
    floorPlanLayout: 'Plano del Piso',
    floorPlanTooSmall: 'El diseño mínimo necesario para las mesas actuales es de',
    floorPlanTooSmallHint: 'Mueve o desactiva mesas para reducir el mínimo',
    fontFamily: 'Familia de Fuente',
    fontSize: 'Tamaño de Fuente',
    footer: 'Pie de Página',
    footerMessages: 'Mensajes del Pie',
    forceLogout: 'Forzar Cierre de Sesión',
    forThisTable: 'para esta mesa',
    frequency: 'Frecuencia',
    friday: 'Viernes',
    friend: 'Amigo',
    from: 'de',
    fullCut: 'Corte completo',
    fullLogin: 'Login Completo',
    fullName: 'Nombre Completo',
    fullscreen: 'Pantalla Completa',
    generateInvoice: 'Generar Factura',
    generatingPdf: 'Generando PDF...',
    getQuantity: 'Cantidad Gratis',
    giftCard: 'Tarjeta de Regalo',
    glutenFree: 'Sin Gluten',
    gotIt: 'Entendido',
    grams: 'g',
    granularity: 'Granularidad de Tiempo',
    gratuity: 'Propina',
    gridSnapDisabled: 'Desactivado (colocación libre)',
    gridSnapSize: 'Tamaño de Cuadrícula',
    group: 'Agrupar',
    groupConfigurationNote: 'Los grupos se configuran según el área de categoría y patrones de nombre. Los cambios afectarán todos los análisis.',
    groupMeetup: 'Reunión de Grupo',
    header: 'Encabezado',
    headerInformation: 'Información del Encabezado',
    height: 'Alto',
    hide: 'Ocultar',
    hideItem: 'Ocultar artículo',
    hideOptions: 'Ocultar Opciones',
    hidePastOrders: 'Ocultar Órdenes Pasadas',
    hidePrintPreview: 'Ocultar vista previa de impresión',
    holdCtrlOrCmd: 'Mantén presionado Ctrl (Windows) o Cmd (Mac) para seleccionar múltiples',
    holdCtrlToSelectMultiple: 'Mantén Ctrl/Cmd para seleccionar múltiples',
    host: 'Anfitrión',
    hour: 'Hora',
    hourlyRate: 'Tarifa por Hora',
    hoursAgo: 'horas atrás',
    howDidYouHearAboutUs: '¿Cómo nos conociste',
    iepsCalculator: 'Calculadora de IEPS',
    iepsReport: 'Reporte IEPS',
    ifTextCutOff: 'Si el texto se corta a la derecha, pruebe con un ancho menor',
    import: 'Importar',
    importe: 'Importe',
    imported: 'importadas',
    importing: 'Importando',
    in: 'en',
    inactive: 'Inactivo',
    inboundInvoices: 'Facturas de Entrada',
    inches: 'pulgadas',
    included: 'incluido',
    includeDiscounts: 'Incluir Descuentos',
    includeIvaBreakdown: 'Incluir desglose de IVA',
    includeQrCode: 'Incluir código QR',
    includes: 'Incluye',
    includeSpecials: 'Incluir Especiales',
    increaseQuantity: 'Aumentar cantidad',
    ingredients: 'Ingredientes',
    inProgress: 'En Progreso',
    inStock: 'En Stock',
    instructions: 'Instrucciones',
    insufficientCash: 'Efectivo insuficiente recibido',
    insufficientPermissions: 'Permisos insuficientes',
    insumoInvoice: 'Insumo (Factura)',
    intoSeparateItems: 'en artículos separados',
    invalidCredentials: 'Credenciales inválidas',
    invalidCsvFormat: 'Formato CSV inválido. Encabezados esperados: Nombre, Fecha de Compra, Precio, IVA',
    invalidEmail: 'Dirección de email inválida',
    invalidFormat: 'Formato inválido',
    invalidPhone: 'Número de teléfono inválido',
    inventory: 'Inventario',
    inventoryManagement: 'Gestión de Inventario',
    inventoryReport: 'Reporte de Inventario',
    invoice: 'Factura',
    invoiceDate: 'Fecha',
    invoiceDetails: 'Detalles de Factura',
    invoiceGeneratedOn: 'Factura generada el',
    invoiceHistory: 'Historial de Facturas',
    invoiceManagement: 'Gestión de Facturas',
    invoiceNotes: 'Notas de Factura',
    invoiceNumber: 'No. Pedido',
    invoices: 'Facturas',
    iosPrintHelp: 'Elige como imprimir tu recibo',
    iosPrintOptions: 'Opciones de Impresion',
    item: 'Artículo',
    itemNotAvailable: 'Artículo no disponible',
    items: 'Artículos',
    itemsAddedSuccessfully: '¡Artículos agregados exitosamente!',
    itemSortOrder: 'Orden de Clasificación de Artículos',
    itemsOverTime: 'Artículos en el Tiempo',
    itemsToBeMoved: 'Artículos a ser movidos',
    itemsToBeMovedBackToParentCheck: 'Artículos a ser movidos de vuelta a la cuenta padre',
    itemsToMove: 'Artículos a Mover',
    itemVisibility: 'Visibilidad de Artículos',
    iva: 'IVA',
    ivaIncluded: 'IVA Incluido',
    justNow: 'Justo ahora',
    kdsEnabled: 'Activar Sistema de Pantalla de Cocina (Estado de Órdenes)',
    kdsEnabledInfo: 'Cuando está activado, la pantalla de Estado de Órdenes / KDS es accesible desde la navegación principal. Desactívalo para ocultarlo a todos los usuarios.',
    key: 'Clave',
    kids: 'Menú Infantil',
    kilograms: 'kg',
    kitchen: 'Cocina',
    kitchenAlert: 'Alerta de cocina',
    kitchenDisplay: 'Pantalla de Cocina',
    kitchenDisplaySettings: 'Sistema de Pantalla de Cocina',
    kitchenError: 'Error de cocina',
    kitchenOutputMode: 'Modo de Salida de Cocina',
    kitchenOutputModeInfo: 'Pantalla: solo KDS. Tickets: imprimir tickets. Ambos: KDS + tickets. Ninguno: desactivado.',
    language: 'Idioma',
    languageSettings: 'Configuración de Idioma',
    last: 'Último',
    lastActivity: 'Última Actividad',
    lastMonth: 'Mes Pasado',
    lastNames: 'Apellidos',
    lastWeek: 'Semana Pasada',
    lastYear: 'Año Pasado',
    layout: 'Diseño',
    light: 'Claro',
    lightTheme: 'Claro',
    line: 'Línea',
    liters: 'L',
    litersSold: 'Litros Vendidos',
    liveMode: 'En Vivo (Tiempo Real)',
    loading: 'Cargando...',
    loadingAvailableOrders: 'Cargando órdenes disponibles...',
    loadingIepsData: 'Cargando datos IEPS',
    loadingInventory: 'Cargando artículos de inventario',
    loadingProductions: 'Cargando corridas de producción',
    loadingSpecials: 'Cargando promociones',
    loadingThemes: 'Cargando temas',
    localTime: 'Hora Local',
    login: 'Iniciar Sesión',
    loginButton: 'Iniciar Sesión',
    loginSuccess: 'Inicio de sesión exitoso',
    loginTime: 'Hora de Inicio',
    logo: 'Logo',
    logout: 'Cerrar Sesión',
    logoutSuccess: 'Cierre de sesión exitoso',
    lowercaseAlphanumericOnly: 'Solo letras minúsculas, números y guiones bajos',
    lowInk: 'Tinta Baja',
    lowStock: 'Stock Bajo',
    lowStockWarning: 'Advertencia de stock bajo',
    loyalty: 'Puntos de Lealtad',
    mainCourse: 'Plato Principal',
    make: 'Hacer',
    manager: 'Gerente',
    mandatory: 'Obligatorio',
    margin: 'Margen',
    markAsDontMake: 'Marcar como No Hacer',
    markAsFeatured: 'Alternar destacado',
    markAsMake: 'Marcar como Hacer',
    maxFileSize: 'Tamaño máximo de archivo',
    maximize: 'Maximizar',
    maximumLength: 'Longitud máxima',
    meat: 'Carne',
    menuAccentColor: 'Color de Acento',
    menuBar: 'Barra de Menú',
    menuBgColor: 'Color de Fondo',
    menuColors: 'Colores del Menú',
    menuColumns: 'Columnas del Menú',
    menuDisplayMode: 'Modo de Visualización del Menú',
    menuEnabled: 'Activar Menú Digital',
    menuEnabledInfo: 'Permite a los clientes ver el menú del restaurante escaneando un código QR.',
    menuFont: 'Fuente del Menú',
    menuHeaderColor: 'Color del Encabezado de Categoría',
    menuManagement: 'Gestión del Menú',
    menuPreview: 'Vista Previa del Menú',
    menuSettings: 'Configuración del Menú',
    menuTextColor: 'Color de Texto',
    meters: 'm',
    metrics: 'Métricas',
    milliliters: 'ml',
    minimize: 'Minimizar',
    minimumLength: 'Longitud mínima',
    minQuantity: 'Cantidad Mínima',
    minutesAgo: 'minutos atrás',
    mobileColumns: 'Columnas móvil',
    modified: 'Modificado',
    monday: 'Lunes',
    month: 'Mes',
    monthly: 'Mensual',
    monthlyAmount: 'Cantidad Mensual',
    monthlyCosts: 'Costos Mensuales',
    monthlyCostsBreakdown: 'Desglose de Costos Mensuales',
    monthlyProfit: 'Ganancia Mensual',
    monthlyRevenue: 'Ingresos Mensuales',
    monthlyRevenueBreakdown: 'Desglose de Ingresos Mensuales',
    monthlySales: 'Ventas Mensuales',
    monthlySummary: 'Resumen Mensual',
    months: 'Meses',
    mostExpensive: 'Más Caro',
    moveSelected: 'Mover Seleccionados',
    moveTable: 'Mover Mesa',
    moveTo: 'Mover a...',
    moveToCheck: 'Mover a Cuenta',
    multipleAllowed: 'múltiples permitidos',
    multipleRegistersActive: 'Múltiples cajas registradoras están abiertas. Por favor seleccione a qué caja pertenece este pago:',
    mustBe: 'debe ser',
    mustBe4Digits: 'debe ser exactamente 4 dígitos',
    name: 'Nombre',
    nameDisplay: 'Mostrar nombres',
    nameDisplayBoth: 'Nombres de grupo y categoría',
    nameDisplayCategories: 'Solo nombres de categoría',
    nameDisplayGroups: 'Solo nombres de grupo',
    nameDisplayNone: 'Sin nombres',
    nameForSplitCheck: 'Nombre para Cuenta Dividida',
    nameSpanish: 'Nombre en Español',
    narrow: 'Angosto',
    networkError: 'Error de red',
    new: 'Nuevo',
    newCheck: 'Nueva Cuenta',
    newGroup: 'Nuevo Grupo',
    newItem: 'Artículo Nuevo',
    newOrder: 'Nueva Orden',
    newOrders: 'Nuevos Pedidos',
    newOrderWillBeCreated: 'Se creará un nuevo pedido independiente para esta factura.',
    newTabName: 'Nombre de Nueva Cuenta',
    next: 'Siguiente',
    no: 'No',
    noActiveRegisterError: 'No hay caja registradora activa. Por favor abra una caja o elija un método de pago diferente.',
    noActiveSessions: 'No hay sesiones activas',
    noApplicableSpecials: 'No hay promociones aplicables en este momento',
    noCategories: 'Sin categorías',
    noClosedSessions: 'No se encontraron sesiones cerradas',
    noCostsAdded: 'No se han agregado costos aún',
    noCostsInCategory: 'No hay costos en esta categoría',
    noData: 'No hay datos disponibles',
    noDiscount: 'Sin descuento',
    noInventoryItemsFound: 'No se encontraron artículos de inventario',
    noInvoiceGenerated: 'No se ha generado factura',
    noInvoicesFound: 'No se encontraron facturas',
    noItems: 'Sin artículos',
    noItemsAssigned: 'No hay artículos asignados',
    noItemsInCheck: 'No hay artículos en esta cuenta',
    noItemsInOrder: 'No hay artículos en este pedido',
    noKitchenOutput: 'Ninguno',
    nonAlcoholic: 'Sin Alcohol',
    none: 'Ninguno',
    noOrderIdProvided: 'No se proporcionó ID de orden',
    noOrdersFound: 'No se encontraron pedidos',
    noPastOrders: 'No se encontraron órdenes pasadas',
    noPaymentRequired: 'No se requiere pago',
    noPayouts: 'No hay pagos para esta sesión',
    noPrinterSelected: 'No se seleccionó impresora. Por favor selecciona una impresora cuando se solicite.',
    noProductionRunsFound: 'No se encontraron corridas de producción',
    noProductsFound: 'No se encontraron productos',
    noResultsFound: 'No se encontraron resultados para',
    noSalesData: 'No se encontraron datos de ventas para este período',
    noSpecialsFound: 'No se encontraron promociones',
    notaDeRemision: 'Nota de Remisión',
    notApplicable: 'N/A',
    notAvailable: 'No disponible',
    notCompatible: 'No compatible',
    note: 'Nota',
    notes: 'Notas',
    notesPlaceholder: 'Ingrese notas o instrucciones especiales...',
    notIncludedInMonthly: 'No incluido en cálculos mensuales',
    noTip: 'Sin Propina',
    noTipConfirm: 'No se ha ingresado propina. Continuar sin propina?',
    nutritionInfo: 'Información Nutricional',
    occupied: 'Ocupada',
    oceanTheme: 'Océano',
    of: 'de',
    offline: 'Fuera de Línea',
    oneTime: 'Una Vez',
    onHold: 'En Espera',
    open: 'Abierta',
    openChecks: 'Cuentas Abiertas',
    openChildrenTabs: 'Cuentas hijas abiertas',
    openDrawer: 'Abrir Cajón',
    opened: 'Abierta',
    openedBy: 'Abierta por',
    opening: 'Abriendo',
    openingCash: 'Efectivo Inicial',
    openOrders: 'Órdenes Abiertas',
    openRegister: 'Abrir Caja',
    openRegisters: 'Cajas Abiertas',
    operationCompleted: 'Operación completada exitosamente',
    operationFailed: 'Operación falló',
    option: 'Opción',
    optional: 'Opcional',
    optionGroup: 'Grupo de Opciones',
    optionGroups: 'Grupos de Opciones',
    optionManagement: 'Gestión de Opciones',
    options: 'Opciones',
    order: 'orden',
    orderCancelled: 'Orden cancelada',
    orderClosedSuccessfully: 'Orden cerrada exitosamente',
    orderCompleted: 'Orden completada',
    orderCreated: 'Orden creada exitosamente',
    orderDelay: 'Notificación de retraso en orden',
    orderDeleted: 'Orden eliminada exitosamente',
    orderDetails: 'Detalles del Pedido',
    orderLabel: 'Etiqueta de orden',
    orderLabelPlaceholder: 'Nombre o número',
    orderLabelsEnabled: 'Etiquetas de orden',
    orderLabelsEnabledInfo: 'Agrega una etiqueta corta a la orden. Cada artículo conserva la etiqueta con la que se envió.',
    orderManagement: 'Gestión de Órdenes',
    orderName: 'Nombre de Orden',
    orderNumber: 'Orden #',
    orderReceived: 'Orden Recibida',
    orderReopenedSuccessfully: 'Pedido reabierto exitosamente',
    orders: 'Órdenes',
    ordersCombinedSuccessfully: 'Órdenes combinadas exitosamente',
    ordersOverTime: 'Órdenes en el Tiempo',
    orderStatus: 'Estado de Orden',
    orderSummary: 'Resumen de Orden',
    orderTime: 'Hora de Orden',
    orderTotal: 'Total',
    orderType: 'Tipo de Orden',
    orderUpdated: 'Orden actualizada',
    ordinal: 'Ordinal',
    organic: 'Orgánico',
    originalCheck: 'Cuenta Original',
    other: 'Otro',
    otherNotSpecified: 'Otro / No Especificado',
    otherPayment: 'Otro Pago',
    ounces: 'oz',
    ourMenu: 'Nuestro Menú',
    outboundInvoices: 'Facturas de Salida',
    outOfStock: 'Agotado',
    outOfStockWarning: 'El artículo está agotado',
    over: 'Sobrante',
    overdue: 'Vencido',
    overtime: 'Tiempo Extra',
    overview: 'Resumen',
    owner: 'Propietario',
    paid: 'Pagado',
    paperCut: 'Corte de Papel',
    paperJam: 'Atasco de Papel',
    paperWidth: 'Ancho del Papel',
    parentOrderId: 'ID de Orden Padre',
    partialCut: 'Corte parcial',
    partialPaymentInfo: 'Un monto menor al saldo se registra y la cuenta permanece abierta.',
    password: 'Contraseña',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    passwordTooShort: 'Contraseña muy corta',
    pasta: 'Pasta',
    paste: 'Pegar',
    pastHour: 'Última Hora',
    pastOrders: 'Órdenes Pasadas',
    pastWeek: 'Última Semana',
    patterns: 'Patrones',
    payment: 'Pago',
    paymentApproved: 'Pago Aprobado',
    paymentDueDays: 'A pagar a más tardar 15 días después de la entrega',
    paymentFailed: 'Pago Rechazado',
    paymentMethod: 'Método de Pago',
    paymentReceived: 'Pago Recibido',
    paymentRecorded: 'Pago registrado',
    paymentsTaken: 'Pagos Registrados',
    paymentTerms: 'Condiciones de Pago',
    payout: 'Pago',
    payoutDepositList: 'Lista de Pagos/Depósitos',
    payoutDescription: 'Agregar descripción...',
    payoutList: 'Lista de Pagos',
    payoutManagement: 'Gestión de Pagos',
    payouts: 'Pagos',
    payoutType: 'Tipo de Pago',
    pending: 'Pendiente',
    pendingApproval: 'Pendiente de Aprobación',
    per: 'por',
    percentage: '%',
    percentageDiscount: 'Descuento Porcentual',
    performance: 'Rendimiento',
    permissionRequired: 'Permiso requerido',
    permissions: 'Permisos',
    pettyCash: 'Caja Chica',
    phone: 'Teléfono',
    phonePlaceholder: 'Ingrese número de teléfono',
    photo: 'Foto',
    photosHowToBody: 'Sube una foto con el botón de cámara junto a cada producto, ya sea aquí en Visibilidad de Categorías o en Administrar Productos. La foto solo aparece en el menú público cuando el producto también está marcado como destacado con el botón de estrella.',
    photosHowToTitle: 'Cómo funcionan las fotos',
    photosSection: 'Fotos',
    pieces: 'piezas',
    pin: 'NIP',
    pinsDoNotMatch: 'Los PINs no coinciden',
    pixels: 'píxeles',
    pizza: 'Pizza',
    placeholder: 'Ingrese valor...',
    pleaseCreateAtLeastOneSplitCheckWithANameAndItems: 'Por favor crea al menos una cuenta dividida con un nombre y artículos',
    pleaseEnterANameForTheSplitCheck: 'Por favor ingresa un nombre para la cuenta dividida',
    pleaseEnterValidDiscountAmount: 'Por favor ingresa una cantidad de descuento válida',
    pleaseProvideDetails: 'Por favor proporciona detalles',
    pleaseProvideDetailsForOther: 'Por favor proporciona detalles al seleccionar "Otro" como razón',
    pleaseProvideNamesForAllSplitChecksThatHaveItems: 'Por favor proporciona nombres para todas las cuentas divididas que tienen artículos',
    pleaseSelectAnOrderToCombineWith: 'Por favor selecciona una orden para combinar',
    pleaseSelectAtLeastOneItemToSplit: 'Por favor selecciona al menos un artículo para dividir',
    pleaseSelectFile: 'Por favor seleccione un archivo',
    pleaseSelectItems: 'Por favor seleccione al menos un artículo',
    pleaseSelectReasonForDeletion: 'Por favor selecciona una razón para la eliminación',
    pleaseSelectRegister: 'Por favor seleccione una caja',
    popular: 'Popular',
    portion: 'porción',
    portionSize: 'Tamaño de Porción',
    poultry: 'Aves',
    pounds: 'lbs',
    pourSizeBreakdown: 'Desglose por Tamaño',
    precio: 'Precio',
    preorderItems: 'Artículos de Pre-orden',
    preparing: 'Preparando',
    prepTime: 'Tiempo de Preparación',
    presentation: 'Presentación',
    preview: 'Vista Previa',
    price: 'Precio',
    priceAdjust: 'Ajuste de Precio',
    priceChangeWarning: 'El precio ha cambiado desde que se realizó la orden',
    primary: 'Primario',
    primaryColor: 'Color Primario',
    print: 'Imprimir',
    printAirprint: 'Imprimir (AirPrint)',
    printDontMakeItems: 'Imprimir items "No Preparar" en tickets',
    printDontMakeItemsInfo: 'Cuando está activado, los items marcados como "No Preparar" aparecerán en los tickets impresos (marcados como NO PREPARAR).',
    printer: 'Impresora',
    printerConfiguration: 'Configuración de Impresora',
    printerManagement: 'Gestión de Impresoras',
    printerMapping: 'Mapeo de Impresora',
    printerMappingHelp: 'Seleccione el dispositivo que corresponde a esta impresora',
    printError: 'Error de impresión',
    printerSettings: 'Configuración de Impresora',
    printerStatus: 'Estado de Impresora',
    printerTestMode: 'Modo de Prueba de Impresora',
    printerType: 'Tipo de Impresora',
    printing: 'Imprimiendo...',
    printInvoice: 'Imprimir Factura',
    printMode: 'Modo de Impresión',
    printModeChangedTo: 'Modo de impresión cambiado a',
    printPreview: 'Vista Previa de Impresión',
    printQueue: 'Cola de Impresión',
    printReceipt: 'Imprimir recibo',
    printTest: 'Prueba de Impresión',
    priority: 'Prioridad',
    processCardPayment: 'Procesar Pago con Tarjeta',
    processing: 'Procesando',
    processingPayment: 'Procesando Pago',
    product: 'Producto',
    productBeer: 'Producto (Cerveza)',
    productCategory: 'Categoría',
    productCode: 'Código de Producto',
    productCreated: 'Producto creado exitosamente',
    productDeleted: 'Producto eliminado exitosamente',
    productDescription: 'Descripción',
    productDisplaySettings: 'Configuración de Visualización de Productos',
    productImage: 'Imagen',
    productionInProgress: 'En Progreso',
    productManagement: 'Gestión de Productos',
    productName: 'Nombre del Producto',
    productPrice: 'Precio',
    products: 'Productos',
    productSalesProjections: 'Proyecciones de Ventas de Productos',
    productsUsingCategory: 'producto(s) lo están usando. Reasigne los productos primero.',
    productUpdated: 'Producto actualizado exitosamente',
    profit: 'Ganancia',
    profitByPeriod: 'Ganancia por Período',
    projections: 'Proyecciones',
    projectionsOverview: 'Resumen de Proyecciones',
    pt210Recommended28: 'Para GOOJPRT PT210, se recomiendan 28 caracteres',
    published: 'Publicado',
    purchaseDate: 'Fecha de Compra',
    qrCodeGenerator: 'Generador de Código QR',
    qrCodeText: 'Texto del código QR',
    qrCodeUrl: 'URL del código QR',
    qty: 'Cant',
    quality: 'Calidad',
    quantity: 'Cantidad',
    quickLogin: 'Acceso Rápido',
    quickOrder: 'Orden Rápida',
    quickTests: 'Pruebas Rápidas',
    ready: 'Listo',
    readyEnroute: 'Listo/En Camino',
    reasonForDeletion: 'Razón para eliminación',
    receipt: 'Recibo',
    receiptFormat: 'Formato de Recibo',
    receiptNumber: 'Número de Recibo',
    receiptsWillPrintAutomatically: 'Los recibos se imprimirán automáticamente según el modo seleccionado',
    receive: 'Recibir',
    received: 'RECIBIDO',
    receivedBy: 'Recibido Por',
    receivedDate: 'Fecha de Recepción',
    recibidoPor: 'Recibido Por',
    recipient: 'Destinatario',
    recipientName: 'Nombre del destinatario',
    recombine: 'Recombinar',
    recombineCheck: 'Recombinar Cuenta',
    recombineSplitCheck: 'Recombinar Cuenta Dividida',
    recombineThisSplitCheckWithItsParent: 'Recombinar esta cuenta dividida con su cuenta padre',
    recombineWarningMessage: 'Esta acción moverá todos los artículos de esta cuenta dividida de vuelta a la orden padre. Esta cuenta dividida será eliminada y no se puede deshacer.',
    recombining: 'Recombinando...',
    recordPayment: 'Registrar Pago',
    records: 'Registros',
    rectangle: 'Rectángulo',
    redo: 'Rehacer',
    refresh: 'Actualizar',
    RefreshData: 'Actualizar Datos',
    refund: 'Reembolso',
    refundConfirmation: '¿Estás seguro de que quieres procesar este reembolso?',
    register: 'Caja',
    registerClosed: 'Caja Cerrada',
    registerManagement: 'Gestión de Cajas',
    registerOpened: 'Caja Abierta',
    reject: 'Rechazar',
    rejected: 'Rechazado',
    remainingBalance: 'Saldo Restante',
    remove: 'Quitar',
    removeItem: 'Eliminar Artículo',
    removePhoto: 'Quitar foto',
    renovation: 'Renovación',
    rent: 'Alquiler',
    reopen: 'Reabrir',
    reopening: 'Reabriendo',
    reopenOrder: 'Reabrir Pedido',
    reorder: 'Reordenar',
    reorderPoint: 'Punto de Reorden',
    reorderThisItem: 'Reordenar este artículo',
    reports: 'Reportes',
    required: 'Requerido',
    reserved: 'Reservada',
    reset: 'Restablecer',
    resetLogo: 'Restablecer',
    resetToDefault: 'Restablecer Predeterminado',
    resetToDefaults: 'Restablecer Predeterminados',
    resetToDefaultsConfirmation: '¿Está seguro de que desea restablecer toda la configuración de impresora a los valores predeterminados?',
    restaurantConfiguration: 'Configuración del Restaurante',
    restaurantSetup: 'Configuración del Restaurante',
    restoreData: 'Restaurar Datos',
    results: 'Resultados',
    retryPayment: 'Reintentar Pago',
    returned: 'Devuelto',
    revenue: 'Ingresos',
    revenueOverTime: 'Ingresos en el Tiempo',
    revenueVsCosts: 'Ingresos vs Costos',
    role: 'Rol',
    roleManagement: 'Gestión de Roles',
    round: 'Redondo',
    rush: 'Orden Urgente',
    safeDeposit: 'Depósito en Caja Fuerte',
    salad: 'Ensalada',
    salary: 'Salario',
    sales: 'Ventas',
    salesAllTime: 'Ventas - Todo el Tiempo',
    salesByCategory: 'Ventas por Categoría',
    salesByGroup: 'Ventas por Grupo',
    salesPerTable: 'Ventas por Mesa',
    salesProjections: 'Proyecciones de Ventas',
    salesProjectionsDescription: 'Configure las ventas esperadas por producto. Use ventas diarias O ventas por mesa (no ambas).',
    salesReport: 'Reporte de Ventas',
    salesValue: 'Valor de Ventas',
    salesYTD: 'Ventas - Año Actual',
    saturday: 'Sábado',
    save: 'Guardar',
    saveBestSettings: 'Guarde su mejor configuración después de probar',
    saveChanges: '¿Guardar cambios?',
    saving: 'Guardando...',
    scale: 'Báscula',
    scanForPrinters: 'Escanear Impresoras',
    scanToViewMenu: 'Escanea para ver nuestro menú',
    schedule: 'Horario',
    seafood: 'Mariscos',
    search: 'Buscar',
    searchCategories: 'Buscar Categorías',
    searchInvoices: 'Buscar facturas...',
    searchOptionGroups: 'Buscar grupos de opciones...',
    searchOptions: 'Buscar opciones...',
    searchOrders: 'Buscar pedidos...',
    searchPlaceholder: 'Buscar...',
    searchProducts: 'Buscar productos...',
    searchSessions: 'Buscar sesiones...',
    searchSpecials: 'Buscar especiales...',
    searchTables: 'Buscar mesas...',
    searchUsers: 'Buscar usuarios...',
    seasonal: 'Estacional',
    seatingCapacity: 'Capacidad de Asientos',
    secondary: 'Secundario',
    secondaryColor: 'Color Secundario',
    select: 'Seleccionar',
    selectAll: 'Seleccionar Todo',
    selectCategory: 'Seleccionar Categoría',
    selected: 'seleccionado',
    selectedByDefault: 'Seleccionado por Defecto',
    selectedItems: 'Artículos Seleccionados',
    selectedOrder: 'Orden Seleccionada (Origen)',
    selectFile: 'Seleccionar Archivo',
    selectInsumo: 'Seleccionar Insumo',
    selectItemsToSplit: 'Seleccionar Artículos para Dividir',
    selectMonth: 'Seleccionar Mes',
    selectMultiple: 'Seleccionar Múltiples',
    selectNone: 'Deseleccionar Todo',
    selectOption: 'Seleccione una opción',
    selectOptionGroup: 'Seleccionar Grupo de Opciones',
    selectOrder: 'Selecciona una orden para combinar',
    selectProduct: 'Seleccionar Producto',
    selectReason: 'Selecciona una razón...',
    selectRegister: 'Seleccionar Caja',
    selectRegisterSession: 'Seleccionar Caja',
    selectTable: 'Seleccionar una mesa',
    selectThisDevice: 'Seleccionar Este Dispositivo',
    selectTimeRange: 'Seleccionar Rango de Tiempo',
    selectType: 'Seleccionar Tipo',
    selectUser: 'Seleccionar Usuario',
    selectYear: 'Seleccionar Año',
    send: 'Enviar',
    sendOrder: 'Enviar Orden',
    serialOnly: 'Solo serial',
    served: 'Servido',
    server: 'Mesero',
    serverError: 'Error del servidor',
    serviceCharge: 'Cargo por servicio',
    serviceChargeEnabled: 'Cargo por servicio',
    serviceChargeEnabledInfo: 'Ofrece un cargo por servicio al cerrar la cuenta. Al desactivarlo se oculta el campo; un cargo que ya tiene una orden se conserva.',
    serviceChargeInfo: 'Se suma al total junto con la propina.',
    serving: 'porción',
    servingTime: 'Tiempo de Servicio',
    session: 'Sesión',
    sessionExpired: 'Sesión expirada',
    sessionHistory: 'Historial de Sesiones',
    sessionId: 'ID de Sesión',
    sessionManagement: 'Gestión de Sesiones',
    sessionSettings: 'Configuración de Sesiones',
    sessionsRefreshAutomatically: 'Las sesiones activas se actualizan automáticamente cada 30 segundos',
    sessionTimeoutHours: 'Horas de Tiempo de Espera de Sesión',
    setAsDefaultDark: 'Fijar como tema oscuro predeterminado',
    setAsDefaultLight: 'Fijar como tema claro predeterminado',
    setDark: 'Fijar Oscuro',
    setLight: 'Fijar Claro',
    setPin: 'Establecer su PIN de 4 dígitos',
    settings: 'Configuración',
    settingsReset: 'Configuración restablecida a valores predeterminados',
    settingsSaved: 'Configuración guardada exitosamente',
    shape: 'Forma',
    shareAsPdf: 'Compartir como PDF',
    shift: 'Turno',
    shiftEnd: 'Fin de Turno',
    shiftStart: 'Inicio de Turno',
    shipped: 'Enviado',
    shippingAddress: 'Dirección de Envío',
    shippingAndHandling: 'Envío y Manejo',
    shippingCost: 'Costo de Envío',
    short: 'Faltante',
    showDeletedTables: 'Mostrar mesas eliminadas',
    showDetails: 'Haga clic para mostrar detalles',
    showInactiveProducts: 'Mostrar Productos Inactivos',
    showInactiveSpecials: 'Mostrar Promociones Inactivas',
    showInactiveUsers: 'Mostrar usuarios inactivos',
    showing: 'Mostrando',
    showItem: 'Mostrar artículo',
    showItemImages: 'Mostrar fotos de productos',
    showItemImagesHint: 'Mostrar fotos en productos marcados como destacados. Desactiva para ocultar todas las fotos sin eliminarlas.',
    showMenuTitle: 'Mostrar título del menú',
    showOnMenu: 'Mostrar en menú',
    showPastOrders: 'Mostrar Órdenes Pasadas',
    showPrintPreview: 'Mostrar vista previa de impresión',
    sidebar: 'Barra Lateral',
    sides: 'Acompañamientos',
    signature: 'Firma',
    size: 'Tamaño',
    smallScreenColumns: 'Columnas pantalla pequeña',
    snapshotSaved: 'Instantánea guardada',
    snapToGrid: 'Ajustar a Cuadrícula',
    sort: 'Ordenar',
    sortCategoriesAlphabetically: 'Ordenar Categorías Alfabéticamente',
    sortCategoriesByDisplayOrder: 'Ordenar Categorías por Orden de Visualización',
    sortItemsAlphabetically: 'Ordenar artículos alfabéticamente por nombre',
    sortItemsByDisplayOrder: 'Ordenar artículos por su orden de visualización asignado (ordinal)',
    sortOrderChangeInfo: 'Los cambios en el orden de clasificación se aplicarán después de actualizar la página',
    soundOff: 'Sonido Desactivado',
    soundOn: 'Sonido Activado',
    soup: 'Sopa',
    spanish: 'Español',
    specialApplied: 'Promoción aplicada exitosamente',
    specialCreated: 'Promoción creada exitosamente',
    specialDeleted: 'Promoción eliminada exitosamente',
    specialDescription: 'Descripción',
    specialInstructions: 'Instrucciones Especiales',
    specialName: 'Nombre de Promoción',
    specials: 'Especialidades del Día',
    specialsAvailable: 'Promociones Disponibles',
    specialsManagement: 'Gestión de Promociones',
    specialType: 'Tipo de Promoción',
    specialUpdated: 'Promoción actualizada exitosamente',
    spicy: 'Picante',
    split: 'Dividir',
    splitAmount: 'Cantidad a Dividir',
    splitBill: 'Dividir Factura',
    splitByItem: 'Dividir por Artículo',
    splitCheck: 'Dividir Cuenta',
    splitCheckDetails: 'Detalles de Cuenta Dividida',
    splitCheckName: 'Nombre de Cuenta Dividida',
    splitChecks: 'Cuentas Divididas',
    splitCustom: 'División Personalizada',
    splitEvenly: 'Dividir Equitativamente',
    splitIntoMultipleChecks: 'Dividir en múltiples cuentas',
    splitItem: 'Dividir Artículo',
    splitPaymentsEnabled: 'Pagos divididos',
    splitPaymentsEnabledInfo: 'Registra más de un pago sobre una cuenta, cada uno con su propio método y propina.',
    splitThisCheck: 'Dividir esta cuenta',
    splitting: 'Dividiendo...',
    splitWarning: 'Esta acción creará cuentas separadas. Asegúrate de revisar los artículos antes de continuar.',
    staff: 'Personal',
    staffPayment: 'Pago a Personal',
    staffReport: 'Reporte de Personal',
    startDate: 'Fecha de Inicio',
    staticMode: 'Estático (Instantánea)',
    status: 'Estado',
    statusBar: 'Barra de Estado',
    stockLevel: 'Nivel de Stock',
    submit: 'Enviar',
    subtotal: 'Subtotal',
    success: 'Éxito',
    successColor: 'Color de Éxito',
    successfullyExportedOrderItems: 'Se exportaron exitosamente {count} artículos de orden a {filename}',
    successfullyImported: 'Se importaron exitosamente {count} de {total} artículos',
    sunday: 'Domingo',
    supplier: 'Proveedor',
    surface: 'Superficie',
    surfaceColor: 'Color de Superficie',
    systemMaintenance: 'Mantenimiento del sistema programado',
    SystemSettings: 'Configuración del Sistema',
    systemSettings: 'Configuración del Sistema',
    table: 'Mesa',
    tableArea: 'Área de Mesa',
    tableAreas: 'Áreas de mesas',
    tableAreasEnabled: 'Áreas de mesas',
    tableAreasEnabledInfo: 'Divide el plano en zonas con nombre y asigna cada mesa a una.',
    tableCreated: 'Mesa creada exitosamente',
    tableDeleted: 'Mesa eliminada exitosamente',
    tableLayout: 'Distribución de Mesas',
    tableManagement: 'Gestión de Mesas',
    tableName: 'Nombre de Mesa',
    tableNumber: 'Mesa #',
    tablePosition: 'Posición de Mesa',
    tables: 'Mesas',
    tablesManagement: 'Gestión de Mesas',
    tablespoons: 'cdas',
    tableStatus: 'Estado',
    tableUpdated: 'Mesa actualizada exitosamente',
    tabs: 'Cuentas',
    takeOut: 'Para Llevar',
    takeSnapshot: 'Tomar Instantánea',
    tax: 'Impuesto',
    taxId: 'RFC',
    taxRate: 'Tasa de impuesto',
    taxRateInfo: 'Porcentaje de IVA incluido en cada precio. Se usa en recibos, tickets y facturas.',
    team: 'Equipo',
    teaspoons: 'cdtas',
    temperature: 'Temperatura',
    terminal: 'Terminal',
    test: 'Probar',
    testModeOnly: 'Solo Modo de Prueba',
    testSections: 'Secciones de Prueba',
    text: 'Texto',
    textColor: 'Color de Texto',
    textLight: 'Texto Claro',
    textLightColor: 'Color de Texto Claro',
    textSecondary: 'Texto Secundario',
    textSecondaryColor: 'Color de Texto Secundario',
    theme: 'Tema',
    themeManagement: 'Gestión de Temas',
    themeName: 'Nombre del Tema',
    themes: 'Temas',
    thermalPrinter: 'Impresora Térmica',
    thermalPrinterControls: 'Controles de Impresora Térmica',
    thermalPrinterOnly: 'Solo impresora térmica',
    thisMonth: 'Este Mes',
    thisNameAlreadyExists: 'Este nombre ya existe',
    thisOrderDoesNotHaveAParentToRecombineWith: 'Esta orden no tiene un padre para recombinar',
    thisWeek: 'Esta Semana',
    thisYear: 'Este Año',
    thursday: 'Jueves',
    ticketsOnly: 'Solo Tickets',
    time: 'Hora',
    timeIn: 'Entrada',
    timeOut: 'Salida',
    timePeriod: 'Período de Tiempo',
    timeRange: 'Rango de Tiempo',
    timestamp: 'Marca de Tiempo',
    timeToFinish: 'Tiempo para terminar',
    timezoneInfo: 'Zona horaria para todas las operaciones relacionadas con el tiempo',
    tip: 'Propina',
    tipAmount: 'Propina',
    tippedOrders: 'Órdenes con Propina',
    tipPercentage: 'Porcentaje de Propina',
    tips: 'Propinas',
    tipsByPaymentMethod: 'Propinas por Método de Pago',
    tipsByServer: 'Propinas por Mesero',
    tipsOverTime: 'Propinas a lo Largo del Tiempo',
    tipsReport: 'Reporte de Propinas',
    today: 'Hoy',
    toDisplay: 'para mostrar',
    tomorrow: 'Mañana',
    toolbar: 'Barra de Herramientas',
    topSelling: 'Más Vendidos',
    total: 'Total',
    totalBeingRecombined: 'Total Siendo Recombinado',
    totalItems: 'artículos totales',
    totalLitersSold: 'Litros Totales Vendidos',
    totalMonthlyCosts: 'Total de Costos Mensuales',
    totalMonthlyRevenue: 'Total de Ingresos Mensuales',
    totalPayouts: 'Total de Pagos',
    totalRegisters: 'Total de Cajas',
    totalRevenue: 'Ingresos Totales',
    totals: 'Totales',
    totalSalesValue: 'Valor Total de Ventas',
    totalServings: 'Servicios Totales',
    totalShifts: 'Total de Turnos',
    totalTables: 'Total de Mesas',
    totalTips: 'Propinas Totales',
    totalToPay: 'Total a Pagar',
    transactionHistory: 'Historial de Transacciones',
    transactions: 'Transacciones',
    tryQuickTests: 'Pruebe primero los botones de prueba rápida para encontrar el mejor ancho para su impresora',
    tuesday: 'Martes',
    unassigned: 'Sin asignar',
    unassignedCategories: 'Categorías Sin Asignar',
    uncategorized: 'Sin Categorizar',
    undo: 'Deshacer',
    unexpectedError: 'Error inesperado',
    ungroup: 'Desagrupar',
    ungrouped: 'Sin Grupo',
    units: 'Unidades',
    unitsSold: 'Unidades Vendidas',
    unknown: 'Desconocido',
    unknownError: 'Error desconocido',
    unknownOther: 'Desconocido/Otro',
    unnamedItem: 'Artículo Sin Nombre',
    unsavedChanges: 'Tienes cambios sin guardar. ¿Estás seguro de que quieres salir?',
    update: 'Actualizar',
    updated: 'Actualizado',
    updateUser: 'Actualizar Usuario',
    upload: 'Subir',
    uploadLogo: 'Subir',
    upTo: 'hasta',
    usbSerialPrinter: 'Impresora USB/Serial',
    useChromeEdgeForThermalPrinters: 'Use Chrome/Edge 89+ para impresoras térmicas USB/Serie',
    useExistingOrder: 'Usar Pedido Existente',
    usePrintTestToVerifyConnection: 'Use "Prueba de Impresión" para verificar la conexión',
    user: 'Usuario',
    userCreated: 'Usuario creado exitosamente',
    userDeleted: 'Usuario eliminado exitosamente',
    userInactive: 'La cuenta de usuario está inactiva. Comuníquese con un administrador.',
    userManagement: 'Gestión de Usuarios',
    username: 'Usuario',
    users: 'Usuarios',
    usersManagement: 'Gestión de Usuarios',
    userUpdated: 'Usuario actualizado exitosamente',
    usingDefaultLogo: 'Usando logo BOCA predeterminado',
    utilities: 'Servicios Públicos',
    validationError: 'Error de validación',
    vegan: 'Vegano',
    vegetarian: 'Vegetariano',
    view: 'Ver',
    viewDiagnostics: 'Ver Diagnósticos',
    viewInvoice: 'Ver Factura',
    voidPaymentConfirmation: '¿Estás seguro de que quieres anular este pago?',
    voidTransaction: 'Anular Transacción',
    waiter: 'Mesero',
    waitress: 'Mesera',
    warning: 'Advertencia',
    warningColor: 'Color de Advertencia',
    webBluetoothApi: 'Web Bluetooth API',
    webSerialApi: 'Web Serial API',
    webSerialApiNotCompatible: 'Web Serial API no compatible',
    wednesday: 'Miércoles',
    weeklySummary: 'Resumen Semanal',
    welcomeBack: 'Bienvenido de Nuevo',
    wide: 'Ancho',
    width: 'Ancho',
    widthHeightMustBe: 'Ancho/Alto debe ser',
    with: 'con',
    without: 'sin',
    withTip: 'Con Propina',
    wrongOrder: 'Orden incorrecta',
    yearly: 'Anual',
    yearlyReport: 'Reporte Anual',
    yes: 'Sí',
    yesterday: 'Ayer',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to Spanish
    return localStorage.getItem('pos-language') || 'es';
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('pos-language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  // Helper to convert any string to lowerCamelCase
  function toLowerCamelCase(str) {
    if (!str) return str;
    // Remove non-alphanumeric, split by word boundaries
    const words = str.match(/[A-Za-z0-9]+/g);
    if (!words) return str;
    return words
      .map((w, i) => i === 0 ? w.charAt(0).toLowerCase() + w.slice(1) : w.charAt(0).toUpperCase() + w.slice(1))
      .join('');
  }

  const translateInLanguage = (key, lang) => {
    if (!key) return key;
    const langKey = translations[lang] ? lang : language;
    const normalizedKey = typeof key === 'string' ? key.toLowerCase() : key;
    const camelKey = typeof key === 'string' ? toLowerCamelCase(key) : key;
    // Try exact match, lowercased, and lowerCamelCase match
    return (
      translations[langKey][key] ||
      translations[langKey][normalizedKey] ||
      translations[langKey][camelKey] ||
      key
    );
  };

  const t = (key) => translateInLanguage(key, language);

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    translateInLanguage,
    isSpanish: language === 'es',
    isEnglish: language === 'en'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};